export const floor_plan = [
  {
    id: "TWt0Zzo6U2VjdGlvbi0xNTI4MjUyMjUzNTg1NTgxMjQwX19fc3R1ZGlv",
    name: "Studio",
    type: "Sub-org",
    createdAt: "2016-03-08T16:35:23Z",
    hasMore: false,
    floorPlans: [
      {
        id: "UHJvcDo6Rmxvb3JQbGFuLTE1Nzg0MjIyMjAwMTY4OTQwMDcX=",
        name: "AveY-S01",
        areaMin: "572",
        areaMax: "572",
        imageName: "area.floorplan_1.png",
        imageUrl:
          "https://s3.amazonaws.com/img.myhyly/1528490190283337776/original.png?1457681836",
        imageSize: 25210,
        imageDimension: "670x499",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly/1528490190283337776/small.png?1457681836",
        createdAt: "2017-09-13T11:05:31Z"
      },
      {
        id: "UHJvcDo6Rmxvb3JQbGFuLTE1Nzg0MjIyMjAwMTY4OTQwMDcY=",
        name: "AveY-S01",
        areaMin: "572",
        areaMax: "572",
        imageName: "data",
        imageUrl:
          "https://s3.amazonaws.com/img.myhyly/1599812397130659765/Abe_Residential/AvenueatYork/optimized/original.?1525699975",
        imageSize: 1102730,
        imageDimension: "8154x6728",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly/1599812397130659765/Abe_Residential/AvenueatYork/optimized/small.?1525699975",
        createdAt: "2017-09-13T11:05:31Z"
      }
    ]
  },
  {
    id: "TWt0Zzo6U2VjdGlvbi0xNTI4MjUyMjUzNTg1NTgxMjQwX19fMS1iZWRyb29t",
    name: "1 Bedroom",
    type: "Sub-org",
    createdAt: "2016-03-08T16:35:23Z",
    hasMore: false,
    floorPlans: [
      {
        id: "UHJvcDo6Rmxvb3JQbGFuLTE1Nzg0MjIyMTk5NTgyNzQ5MTY=",
        name: "AveY-A01",
        areaMin: "628",
        areaMax: "628",
        imageName: "area.floorplan_2.png",
        imageUrl:
          "https://s3.amazonaws.com/img.myhyly/1528490219389595488/original.png?1457681864",
        imageSize: 27659,
        imageDimension: "670x499",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly/1528490219389595488/small.png?1457681864",
        createdAt: "2017-09-13T11:05:31Z"
      }
    ]
  },
  {
    id: "TWt0Zzo6U2VjdGlvbi0xNTI4MjUyMjUzNTg1NTgxMjQwX19fMi1iZWRyb29tcw==",
    name: "2 Bedrooms",
    type: "Sub-org",
    createdAt: "2016-03-08T16:35:23Z",
    hasMore: false,
    floorPlans: [
      {
        id: "UHJvcDo6Rmxvb3JQbGFuLTE1Nzg0MjIyMTk4MzkwMTUwNzc=",
        name: "AveY-B01",
        areaMin: "1065",
        areaMax: "1065",
        imageName: "area.floorplan_4.png",
        imageUrl:
          "https://s3.amazonaws.com/img.myhyly/1528490239732426407/original.png?1457681883",
        imageSize: 101404,
        imageDimension: "665x495",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly/1528490239732426407/small.png?1457681883",
        createdAt: "2017-09-13T11:05:31Z"
      }
    ]
  }
];

export const categories = [
  {
    id: "TWt0Zzo6U2VjdGlvbi0xNTI4MjUyMjUzNTg1NTgxMjQwX19fYW1lbml0eQ==",
    name: "Amenities",
    type: "Sub-org",
    createdAt: "2016-03-08T16:35:23Z",
    hasMore: false,
    assets: [
      {
        id: "UHJvcDo6R2FsbGVyeUFzc2V0LTE1Mjg0ODc5NzI1MzM5MTM3OTY=",
        name: "amenities-slide-2",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528487972533913796/original.jpg?1508235412",
        fileSize: "88442",
        fileType: "JPEG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528487972533913796/small.jpg?1508235412",
        createdAt: "2016-03-11T07:02:02Z"
      },
      {
        id: "UHJvcDo6R2FsbGVyeUFzc2V0LTE1Mjg0ODc5NzQyOTIzMzQxMTc=",
        name: "amenities-slide-1",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528487974292334117/original.jpg?1508236103",
        fileSize: "236651",
        fileType: "JPEG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528487974292334117/small.jpg?1508236103",
        createdAt: "2016-03-11T07:02:04Z"
      },
      {
        id: "UHJvcDo6R2FsbGVyeUFzc2V0LTE1Mjg0ODc5NzQyMjg3MTU4MTg=",
        name: "amenities-slide-3",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528487974228715818/original.jpg?1508236105",
        fileSize: "248699",
        fileType: "JPEG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528487974228715818/small.jpg?1508236105",
        createdAt: "2016-03-11T07:02:03Z"
      },
      {
        id: "UHJvcDo6R2FsbGVyeUFzc2V0LTE1Mjg0ODc5NzQ4NDQyNTk4MDA=",
        name: "amenities-slide-4",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528487974844259800/original.jpg?1508236104",
        fileSize: "337634",
        fileType: "JPEG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528487974844259800/small.jpg?1508236104",
        createdAt: "2016-03-11T07:02:04Z"
      }
    ]
  },
  {
    id: "TWt0Zzo6U2VjdGlvbi0xNjM3MjM3Mzk5NDE4NTYyMjE3",
    name: "Awesome Section",
    type: "Sub-org",
    createdAt: "2019-06-24T15:47:37Z",
    hasMore: false,
    assets: [
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE2MzcyMzc0NTgzMDk1ODIwODA=",
        name: "Awesome_Image",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1637237458309582080/original.png?1561391313",
        fileSize: "10456",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1637237458309582080/small.png?1561391313",
        createdAt: "2019-06-24T15:48:33Z"
      }
    ]
  },
  {
    id: "TWt0Zzo6U2VjdGlvbi0xNTI4MjUyMjUzNTg1NTgxMjQwX19fZXh0ZXJpb3I=",
    name: "Exterior",
    type: "Sub-org",
    createdAt: "2016-03-08T16:35:23Z",
    hasMore: false,
    assets: [
      {
        id: "UHJvcDo6R2FsbGVyeUFzc2V0LTE1NTU4MjA2ODE3NDA0NDIxNDg=",
        name: "Galleryexterior(3)",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1555820681740442148/original.png?1508236100",
        fileSize: "2777373",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1555820681740442148/small.png?1508236100",
        createdAt: "2017-01-06T23:43:45Z"
      }
    ]
  },
  {
    id: "TWt0Zzo6U2VjdGlvbi0xNTI4MjUyMjUzNTg1NTgxMjQwX19faW50ZXJpb3I=",
    name: "Interior",
    type: "Sub-org",
    createdAt: "2016-03-08T16:35:23Z",
    hasMore: false,
    assets: [
      {
        id: "UHJvcDo6R2FsbGVyeUFzc2V0LTE1Mjg0ODc5MjQ1MzMwNTE5NTQ=",
        name: "interior-slide-2",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528487924533051954/original.jpg?1508235414",
        fileSize: "213088",
        fileType: "JPEG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528487924533051954/small.jpg?1508235414",
        createdAt: "2016-03-11T07:01:16Z"
      },
      {
        id: "UHJvcDo6R2FsbGVyeUFzc2V0LTE1Mjg0ODc5MjUxNzczMTgyODQ=",
        name: "interior-slide-1",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528487925177318284/original.jpg?1508235413",
        fileSize: "164243",
        fileType: "JPEG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528487925177318284/small.jpg?1508235413",
        createdAt: "2016-03-11T07:01:17Z"
      },
      {
        id: "UHJvcDo6R2FsbGVyeUFzc2V0LTE1Mjg0ODc5Mjg4MjYzNTUxMTA=",
        name: "interior-slide-5",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528487928826355110/original.jpg?1508236107",
        fileSize: "121573",
        fileType: "JPEG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528487928826355110/small.jpg?1508236107",
        createdAt: "2016-03-11T07:01:20Z"
      },
      {
        id: "UHJvcDo6R2FsbGVyeUFzc2V0LTE1Mjg0ODc5Mjg2NTcwODk0NzM=",
        name: "interior-slide-3",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528487928657089473/original.jpg?1508236108",
        fileSize: "215341",
        fileType: "JPEG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528487928657089473/small.jpg?1508236108",
        createdAt: "2016-03-11T07:01:20Z"
      }
    ]
  },
  {
    id: "TWt0Zzo6U2VjdGlvbi0xNTI4MjUyMjUzNTg1NTgxMjQwX19fbmVpZ2hib3Job29k",
    name: "Neighborhood",
    type: "Sub-org",
    createdAt: "2016-03-08T16:35:23Z",
    hasMore: false,
    assets: [
      {
        id: "UHJvcDo6R2FsbGVyeUFzc2V0LTE1Mjg0ODc5ODMwODcwOTE1NDc=",
        name: "neighborhood-slide-3",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528487983087091547/original.jpg?1508235411",
        fileSize: "216276",
        fileType: "JPEG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528487983087091547/small.jpg?1508235411",
        createdAt: "2016-03-11T07:02:12Z"
      },
      {
        id: "UHJvcDo6R2FsbGVyeUFzc2V0LTE1Mjg0ODc5ODQxNDAwNjA5Nzg=",
        name: "neighborhood-slide-4",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528487984140060978/original.jpg?1508236102",
        fileSize: "278438",
        fileType: "JPEG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528487984140060978/small.jpg?1508236102",
        createdAt: "2016-03-11T07:02:13Z"
      },
      {
        id: "UHJvcDo6R2FsbGVyeUFzc2V0LTE1Mjg0ODc5ODM5NjY3NjM0NTE=",
        name: "neighborhood-slide-2",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528487983966763451/original.jpg?1508236936",
        fileSize: "287891",
        fileType: "JPEG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528487983966763451/small.jpg?1508236936",
        createdAt: "2016-03-11T07:02:13Z"
      }
    ]
  },
  {
    id: "TWt0Zzo6U2VjdGlvbi0xNTMxMDUxMjkyNDIzMjg0MjU4",
    name: "New",
    type: "Sub-org",
    createdAt: "2016-04-08T14:04:54Z",
    hasMore: false,
    assets: [
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1MjgyNTg5NzIyODM1NDQwMjY=",
        name: "Avenu-At-York-Email-logo",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1528258972283544026/original.png?1457461330",
        fileSize: "6325",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1528258972283544026/small.png?1457461330",
        createdAt: "2016-03-08T18:22:10Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1MjgyNTk0OTUyODU2Njg5Nzg=",
        name: "Avenu-At-York-Email-logo",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1528259495285668978/original.png?1457461828",
        fileSize: "6325",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1528259495285668978/small.png?1457461828",
        createdAt: "2016-03-08T18:30:29Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1MjgyNzEzNTc0MTA3NDUzMDA=",
        name: "hero",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1528271357410745300/original.png?1457473141",
        fileSize: "254551",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1528271357410745300/small.png?1457473141",
        createdAt: "2016-03-08T21:39:02Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1MjgyNzEzNzE3NjYyMzQyNDY=",
        name: "image-1",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1528271371766234246/original.png?1457473155",
        fileSize: "110017",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1528271371766234246/small.png?1457473155",
        createdAt: "2016-03-08T21:39:15Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1MjgyNzEzODg4NTY1MTMxMDc=",
        name: "image-2",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1528271388856513107/original.png?1457473171",
        fileSize: "75988",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1528271388856513107/small.png?1457473171",
        createdAt: "2016-03-08T21:39:32Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1Mjg3Nzc0NTUxMTY2MzI3NDE=",
        name: "contact-thumbnail",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1528777455116632741/original.png?1457955793",
        fileSize: "5760",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1528777455116632741/small.png?1457955793",
        createdAt: "2016-03-14T11:43:14Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1Mjk3MDM4NzUwODYwNzIwMzY=",
        name: "AveAtYork-blue",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1529703875086072036/original.png?1458839296",
        fileSize: "9739",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1529703875086072036/small.png?1458839296",
        createdAt: "2016-03-24T17:08:17Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1Mjk3MDk3NjM2MDAwMzUzOTI=",
        name: "AveAtYork-blue",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1529709763600035392/original.png?1458844912",
        fileSize: "9739",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1529709763600035392/small.png?1458844912",
        createdAt: "2016-03-24T18:41:53Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1Mjk3MTMwNDE0NTEwNjE4Njk=",
        name: "splash-demo",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1529713041451061869/original.jpg?1458848038",
        fileSize: "218043",
        fileType: "JPEG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1529713041451061869/small.jpg?1458848038",
        createdAt: "2016-03-24T19:33:59Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1Mjk3OTUyMDA3Nzk0NzA4NjE=",
        name: "splash-demo",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1529795200779470861/original.jpg?1458926391",
        fileSize: "218043",
        fileType: "JPEG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1529795200779470861/small.jpg?1458926391",
        createdAt: "2016-03-25T17:19:52Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1Mjk3OTU4OTgyMTEwODc2Mjc=",
        name: "splash-demo",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1529795898211087627/original.jpg?1458927056",
        fileSize: "218043",
        fileType: "JPEG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1529795898211087627/small.jpg?1458927056",
        createdAt: "2016-03-25T17:30:57Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1MzAxNjUzMzk3MzI3MzkyNjA=",
        name: "Happy_Hour",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1530165339732739260/original.png?1459279383",
        fileSize: "362748",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1530165339732739260/small.png?1459279383",
        createdAt: "2016-03-29T19:23:04Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1MzAxNjYwNTgyMDQyNjMwNDg=",
        name: "Happy_Hour",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1530166058204263048/original.png?1459280068",
        fileSize: "362748",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1530166058204263048/small.png?1459280068",
        createdAt: "2016-03-29T19:34:29Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1MzI5NzY0MDg1NzE1OTEwMzk=",
        name: "tutorial_add-image-slice-splash",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1532976408571591039/original.jpg?1461960227",
        fileSize: "135013",
        fileType: "JPEG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1532976408571591039/small.jpg?1461960227",
        createdAt: "2016-04-29T20:03:48Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1MzI5NzcwODY0MjA4NTQ0MjY=",
        name: "tutorial_add-image-slice-splash",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1532977086420854426/original.jpg?1461960874",
        fileSize: "135013",
        fileType: "JPEG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1532977086420854426/small.jpg?1461960874",
        createdAt: "2016-04-29T20:14:34Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1MzMyNDczMzYwNjAxNDA2MDM=",
        name: "tutorial-happy-hour-email",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1533247336060140603/original.jpg?1462218604",
        fileSize: "259488",
        fileType: "JPEG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1533247336060140603/small.jpg?1462218604",
        createdAt: "2016-05-02T19:50:05Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1MzMyNDc2MDY2OTgyNTIyMjY=",
        name: "tutorial-happy-hour-email",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1533247606698252226/original.jpg?1462218862",
        fileSize: "259488",
        fileType: "JPEG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1533247606698252226/small.jpg?1462218862",
        createdAt: "2016-05-02T19:54:23Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1MzMzNDIzNzM5ODM5Mjk3MDc=",
        name: "tutorial-happy-hour-email",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1533342373983929707/original.jpg?1462309239",
        fileSize: "259488",
        fileType: "JPEG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1533342373983929707/small.jpg?1462309239",
        createdAt: "2016-05-03T21:00:40Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1MzM0MzE3NDY4OTg5MTM4Mzg=",
        name: "tutorial_add-image-slice-splash",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1533431746898913838/original.jpg?1462394472",
        fileSize: "135013",
        fileType: "JPEG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1533431746898913838/small.jpg?1462394472",
        createdAt: "2016-05-04T20:41:12Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1MzM0MzE3OTM5NjI1MTg0ODM=",
        name: "tutorial_add-image-slice_fp",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1533431793962518483/original.jpg?1462394517",
        fileSize: "160892",
        fileType: "JPEG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1533431793962518483/small.jpg?1462394517",
        createdAt: "2016-05-04T20:41:57Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1MzM0MzIyMjA0MTYzMjkxMjU=",
        name: "tutorial_add-image-slice_fp",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1533432220416329125/original.jpg?1462394923",
        fileSize: "160892",
        fileType: "JPEG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1533432220416329125/small.jpg?1462394923",
        createdAt: "2016-05-04T20:48:44Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1MzM1MTcwMTI2MzIxMDI1Mjk=",
        name: "tutorial_add-image-slice_fp",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1533517012632102529/original.jpg?1462475787",
        fileSize: "160892",
        fileType: "JPEG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1533517012632102529/small.jpg?1462475787",
        createdAt: "2016-05-05T19:16:28Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1MzQyNDMyMzIzNjEzMjU2NTE=",
        name: "AdobeStock_3120383",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1534243232361325651/original.jpeg?1463168364",
        fileSize: "539767",
        fileType: "JPEG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1534243232361325651/small.jpeg?1463168364",
        createdAt: "2016-05-13T19:39:25Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1MzQyNDMyNjg2NTkwMTM4Mzg=",
        name: "1458249230365_CanvasPoster4",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1534243268659013838/original.jpg?1463168399",
        fileSize: "57087",
        fileType: "JPEG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1534243268659013838/small.jpg?1463168399",
        createdAt: "2016-05-13T19:40:00Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1MzQ1MDYzMTQ3NTE3ODg5NDA=",
        name: "newyears520x300",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1534506314751788940/original.jpg?1463419260",
        fileSize: "229820",
        fileType: "JPEG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1534506314751788940/small.jpg?1463419260",
        createdAt: "2016-05-16T17:21:00Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1MzQ1MDY2OTc2Nzk2NjgxMjM=",
        name: "superbowl520X300",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1534506697679668123/original.jpg?1463419625",
        fileSize: "282300",
        fileType: "JPEG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1534506697679668123/small.jpg?1463419625",
        createdAt: "2016-05-16T17:27:05Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1MzQ1MDY5MjcxODQ3OTg2ODI=",
        name: "easter520X300",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1534506927184798682/original.jpg?1463419844",
        fileSize: "201028",
        fileType: "JPEG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1534506927184798682/small.jpg?1463419844",
        createdAt: "2016-05-16T17:30:44Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1MzQ1MDcyMDM3NDI5NjE0MzY=",
        name: "amenities520X300",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1534507203742961436/original.jpg?1463420107",
        fileSize: "277038",
        fileType: "JPEG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1534507203742961436/small.jpg?1463420107",
        createdAt: "2016-05-16T17:35:08Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1MzQ1MDczNTAxMzgxOTgwMjM=",
        name: "halloween520X300",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1534507350138198023/original.jpg?1463420247",
        fileSize: "227477",
        fileType: "JPEG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1534507350138198023/small.jpg?1463420247",
        createdAt: "2016-05-16T17:37:28Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1MzQ1MDc2MTU0NDk2MzY5NDU=",
        name: "4thofjuly520X300",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1534507615449636945/original.jpg?1463420500",
        fileSize: "244015",
        fileType: "JPEG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1534507615449636945/small.jpg?1463420500",
        createdAt: "2016-05-16T17:41:41Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1MzQ1MDk2MDI3NDg1NzM1MTM=",
        name: "stpat520X300",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1534509602748573513/original.jpg?1463422395",
        fileSize: "181651",
        fileType: "JPEG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1534509602748573513/small.jpg?1463422395",
        createdAt: "2016-05-16T18:13:16Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1MzQ1MDk3NzU3NDAzODUzMTk=",
        name: "multifamily-event_invitation",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1534509775740385319/original.jpg?1463422560",
        fileSize: "177504",
        fileType: "JPEG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1534509775740385319/small.jpg?1463422560",
        createdAt: "2016-05-16T18:16:01Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1MzQ1MDk5NTk5NjgxNjExMjY=",
        name: "building",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1534509959968161126/original.jpg?1463422736",
        fileSize: "205109",
        fileType: "JPEG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1534509959968161126/small.jpg?1463422736",
        createdAt: "2016-05-16T18:18:57Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1NTY0NTIzNjYxMTMwMjg4Mzc=",
        name: "shopping",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1556452366113028837/original.png?1484348644",
        fileSize: "255094",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1556452366113028837/small.png?1484348644",
        createdAt: "2017-01-13T23:04:06Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1NTY3MDMyODkwMzgxMTI1NDY=",
        name: "coffeehouse520x300",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1556703289038112546/original.png?1484587943",
        fileSize: "263277",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1556703289038112546/small.png?1484587943",
        createdAt: "2017-01-16T17:32:25Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1NTY3MDMzNDc2NTYxMzA1NzI=",
        name: "dayspa520x300",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1556703347656130572/original.png?1484587999",
        fileSize: "302604",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1556703347656130572/small.png?1484587999",
        createdAt: "2017-01-16T17:33:20Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1NTY3MDM0Mzg2NzkzMjcyODk=",
        name: "thriftstore520x300",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1556703438679327289/original.png?1484588085",
        fileSize: "326762",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1556703438679327289/small.png?1484588085",
        createdAt: "2017-01-16T17:34:47Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1NTY3MDQwMjk5NDcyODgxMDY=",
        name: "yoga-520x300",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1556704029947288106/original.png?1484588650",
        fileSize: "210462",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1556704029947288106/small.png?1484588650",
        createdAt: "2017-01-16T17:44:11Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1NTY3MDQwNjY4MzIzMDI4MTA=",
        name: "petpark520x300",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1556704066832302810/original.png?1484588685",
        fileSize: "395551",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1556704066832302810/small.png?1484588685",
        createdAt: "2017-01-16T17:44:46Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1NTY3MDQ0OTk2MjEwMDMyNzk=",
        name: "pet-520x300",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1556704499621003279/original.png?1484589098",
        fileSize: "271237",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1556704499621003279/small.png?1484589098",
        createdAt: "2017-01-16T17:51:39Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1NTY3MDQ4MzYwNjQyNDQ5NzU=",
        name: "pets1-520x300",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1556704836064244975/original.png?1484589418",
        fileSize: "224520",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1556704836064244975/small.png?1484589418",
        createdAt: "2017-01-16T17:57:00Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1NTY3MDg5MDIyMjQzMzk5OTM=",
        name: "pool-520x300",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1556708902224339993/original.png?1484593296",
        fileSize: "374637",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1556708902224339993/small.png?1484593296",
        createdAt: "2017-01-16T19:01:38Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1NTY3MTMzMDAzOTgzNjYzNDc=",
        name: "staff-520x300",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1556713300398366347/original.png?1484597491",
        fileSize: "237236",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1556713300398366347/small.png?1484597491",
        createdAt: "2017-01-16T20:11:32Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1NTY3MTU5MDE3NTMxNDYwOTE=",
        name: "4thofjuly520X300",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1556715901753146091/original.jpg?1484599972",
        fileSize: "244015",
        fileType: "JPEG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1556715901753146091/small.jpg?1484599972",
        createdAt: "2017-01-16T20:52:53Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1NTY3MTc0NzYzOTU2OTUwMzI=",
        name: "hyTours-laptop",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1556717476395695032/original.gif?1484601470",
        fileSize: "2496008",
        fileType: "GIF",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1556717476395695032/small.gif?1484601470",
        createdAt: "2017-01-16T21:17:55Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1NTY3MTgxMTg0MjgxMTQyMTE=",
        name: "lease-520x300_",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1556718118428114211/original.png?1484602085",
        fileSize: "219820",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1556718118428114211/small.png?1484602085",
        createdAt: "2017-01-16T21:28:07Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1NTY3MjM0MTE0NDgxNTc1MjU=",
        name: "superbowl520X300",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1556723411448157525/original.jpg?1484607133",
        fileSize: "282300",
        fileType: "JPEG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1556723411448157525/small.jpg?1484607133",
        createdAt: "2017-01-16T22:52:15Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1NTY3MjQ3NzA2MjIxODc1NTI=",
        name: "onboarding-520x300",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1556724770622187552/original.png?1484608430",
        fileSize: "251321",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1556724770622187552/small.png?1484608430",
        createdAt: "2017-01-16T23:13:51Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1NTY3MjUyNDk5NTc5NzM2MTI=",
        name: "movingin-520x300",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1556725249957973612/original.png?1484608887",
        fileSize: "283083",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1556725249957973612/small.png?1484608887",
        createdAt: "2017-01-16T23:21:28Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1NTY3MjYxNTEyNTkzNjE3ODY=",
        name: "home-520x300",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1556726151259361786/original.png?1484609747",
        fileSize: "224490",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1556726151259361786/small.png?1484609747",
        createdAt: "2017-01-16T23:35:48Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1NTY3MjY1ODIxMzg3NDA5MDk=",
        name: "lease-520x300__copy",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1556726582138740909/original.png?1484610157",
        fileSize: "275346",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1556726582138740909/small.png?1484610157",
        createdAt: "2017-01-16T23:42:39Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1NTc3MjI0NzAxODcwNjg5NzE=",
        name: "template-6",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1557722470187068971/original.png?1485559910",
        fileSize: "198298",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1557722470187068971/small.png?1485559910",
        createdAt: "2017-01-27T23:31:51Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1NTc3MjI2Nzc2MDM1MDYyMTg=",
        name: "Schedule_a_Tour",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1557722677603506218/original.png?1485560106",
        fileSize: "255713",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1557722677603506218/small.png?1485560106",
        createdAt: "2017-01-27T23:35:09Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1NTgwNTc2MjA0NjU1ODk5NTc=",
        name: "Clearning-carpet",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1558057620465589957/original.png?1485879534",
        fileSize: "256427",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1558057620465589957/small.png?1485879534",
        createdAt: "2017-01-31T16:18:56Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1NTk0MzM5OTI4NjQ1OTQxMzI=",
        name: "avenue_at_york-icon-instagram",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1559433992864594132/original.png?1487192144",
        fileSize: "985",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1559433992864594132/original.png?1487192144",
        createdAt: "2017-02-15T20:55:47Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1NTk0MzM5OTI5MDI3NzM2NDQ=",
        name: "avenue_at_york-icon-facebook",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1559433992902773644/original.png?1487192145",
        fileSize: "917",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1559433992902773644/original.png?1487192145",
        createdAt: "2017-02-15T20:55:47Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1NTk0MzM5OTMzMTk1MzUyMTA=",
        name: "fairfax_res_company_logo",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1559433993319535210/original.png?1487192145",
        fileSize: "2019",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1559433993319535210/small.png?1487192145",
        createdAt: "2017-02-15T20:55:47Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1NTk0MzM5OTM3MDY4NDI2Mjk=",
        name: "avenue_at_york-icon-twitter",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1559433993706842629/original.png?1487192146",
        fileSize: "950",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1559433993706842629/original.png?1487192146",
        createdAt: "2017-02-15T20:55:47Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1NTk0NDEyNjk1MDgyMDQ0NTU=",
        name: "avenue_at_york_logo_(290_x_49)",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1559441269508204455/original.png?1487199085",
        fileSize: "13593",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1559441269508204455/small.png?1487199085",
        createdAt: "2017-02-15T22:51:26Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1NTk5ODM4MDA5NTE4NDk5NTk=",
        name: "Happy-Hour",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1559983800951849959/original.png?1487716483",
        fileSize: "433636",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1559983800951849959/small.png?1487716483",
        createdAt: "2017-02-21T22:34:44Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1NjAwNzE4NjUxMTA5NDMwOTc=",
        name: "neighborhood-1",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1560071865110943097/original.png?1487800468",
        fileSize: "312469",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1560071865110943097/small.png?1487800468",
        createdAt: "2017-02-22T21:54:29Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1NjAwNzE4ODgzMjkzNzA4Nzk=",
        name: "neighborhood-2",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1560071888329370879/original.png?1487800490",
        fileSize: "200279",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1560071888329370879/small.png?1487800490",
        createdAt: "2017-02-22T21:54:51Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1NjAwNzE5MDIwNDQ1ODIyNzA=",
        name: "neighborhood-3",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1560071902044582270/original.png?1487800503",
        fileSize: "166414",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1560071902044582270/small.png?1487800503",
        createdAt: "2017-02-22T21:55:04Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1NjAwNzUyNzQ5OTcwMzIzNjk=",
        name: "avenue_at_york-icon-instagram_sq",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1560075274997032369/original.png?1487803720",
        fileSize: "682",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1560075274997032369/original.png?1487803720",
        createdAt: "2017-02-22T22:48:41Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1NjAwNzUyOTQ1NjQzOTY0NDU=",
        name: "avenue_at_york-icon-twitter_sq",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1560075294564396445/original.png?1487803738",
        fileSize: "641",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1560075294564396445/original.png?1487803738",
        createdAt: "2017-02-22T22:49:00Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1NjAwNzUzMTQxMTYwMDE2NzY=",
        name: "avenue_at_york-icon-facebook_sq",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1560075314116001676/original.png?1487803757",
        fileSize: "688",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1560075314116001676/original.png?1487803757",
        createdAt: "2017-02-22T22:49:18Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1NjE5NDYxMTYwNjQwOTA3MTQ=",
        name: "neighborhood-3_v2",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1561946116064090714/original.png?1489587893",
        fileSize: "27964",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1561946116064090714/small.png?1489587893",
        createdAt: "2017-03-15T14:24:54Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1NjUxMDQ2Mzc3NjUyNzM5ODU=",
        name: "580x326",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1565104637765273985/original.png?1492600094",
        fileSize: "332336",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1565104637765273985/small.png?1492600094",
        createdAt: "2017-04-19T11:08:15Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1NjY0MDcyMjI2MDk0NzcwNDM=",
        name: "Feature_Image",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1566407222609477043/original.png?1493842336",
        fileSize: "319410",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1566407222609477043/small.png?1493842336",
        createdAt: "2017-05-03T20:12:17Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1NjY0MDcyODA0NDUwNDc1MTE=",
        name: "Feature_Image",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1566407280445047511/original.png?1493842391",
        fileSize: "376989",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1566407280445047511/small.png?1493842391",
        createdAt: "2017-05-03T20:13:12Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1NjY0MDczNjAzNTY4NTcyNjg=",
        name: "Left_Image",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1566407360356857268/original.png?1493842467",
        fileSize: "175487",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1566407360356857268/small.png?1493842467",
        createdAt: "2017-05-03T20:14:28Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1NjY0MDc0MTg1OTIzMDczNzM=",
        name: "Right_Image",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1566407418592307373/original.png?1493842523",
        fileSize: "190785",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1566407418592307373/small.png?1493842523",
        createdAt: "2017-05-03T20:15:24Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1NjY0MDgyMjQwNDAyMDcwNTA=",
        name: "Feature_Image",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1566408224040207050/original.png?1493843291",
        fileSize: "443658",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1566408224040207050/small.png?1493843291",
        createdAt: "2017-05-03T20:28:12Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1NjY0MDkwODgyMjAwNjQ3MjA=",
        name: "Feature_Image",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1566409088220064720/original.png?1493844115",
        fileSize: "372127",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1566409088220064720/small.png?1493844115",
        createdAt: "2017-05-03T20:41:56Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1NjY0MTI1NjY0OTQ2NzA5ODU=",
        name: "memorial-day-open-house-feat-image-l",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1566412566494670985/original.png?1493847432",
        fileSize: "292758",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1566412566494670985/small.png?1493847432",
        createdAt: "2017-05-03T21:37:13Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1NjY0MTI5NjU0OTMxNzMxMzk=",
        name: "memorial-day-offer-feat-image-l",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1566412965493173139/original.png?1493847813",
        fileSize: "322164",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1566412965493173139/small.png?1493847813",
        createdAt: "2017-05-03T21:43:34Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1NjY0MTMwODE4Njc1ODE4Njg=",
        name: "pool-opening-feat-image-l",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1566413081867581868/original.png?1493847924",
        fileSize: "460301",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1566413081867581868/small.png?1493847924",
        createdAt: "2017-05-03T21:45:25Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1Njk0ODM0MjY1MzY3Mjg1Mzc=",
        name: "4th_July_img_12",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1569483426536728537/original.png?1496776032",
        fileSize: "485782",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1569483426536728537/small.png?1496776032",
        createdAt: "2017-06-06T19:07:13Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1Njk0ODM1OTU5OTk1OTk2ODM=",
        name: "4th_July_img_1",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1569483595999599683/original.png?1496776193",
        fileSize: "286764",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1569483595999599683/small.png?1496776193",
        createdAt: "2017-06-06T19:09:55Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1Njk0ODM4NjkzMDI2NjU2NTM=",
        name: "4th_July_img_6",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1569483869302665653/original.png?1496776454",
        fileSize: "350668",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1569483869302665653/small.png?1496776454",
        createdAt: "2017-06-06T19:14:16Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1NzEwNzk4OTI5NjExMzEyMjc=",
        name: "transparent-test",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1571079892961131227/original.png?1498298541",
        fileSize: "23516",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1571079892961131227/small.png?1498298541",
        createdAt: "2017-06-24T10:02:22Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1NzE0Nzk2MDAzMDE1MzY5NjU=",
        name: "1bedroom-Search",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1571479600301536965/original.gif?1498679731",
        fileSize: "163113",
        fileType: "GIF",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1571479600301536965/small.gif?1498679731",
        createdAt: "2017-06-28T19:55:33Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1NzMyMDc4MTExOTYxMzU1MzY=",
        name: "2017-07-13_14-54-12",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1573207811196135536/original.png?1500327881",
        fileSize: "80271",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1573207811196135536/small.png?1500327881",
        createdAt: "2017-07-17T21:44:43Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1NzU3MjA2MDkzODQyMDczNjU=",
        name: "NeighborhoodCoffee-580x326",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1575720609384207365/original.png?1502724274",
        fileSize: "312469",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1575720609384207365/small.png?1502724274",
        createdAt: "2017-08-14T15:24:35Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1NzU3MjA2NjQxNTU1MDk4NTQ=",
        name: "NeighborhoodSpa-580x326",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1575720664155509854/original.png?1502724326",
        fileSize: "367193",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1575720664155509854/small.png?1502724326",
        createdAt: "2017-08-14T15:25:27Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1NzU3MjA2OTUxOTAxNDUwNjM=",
        name: "NeighborhoodClothing-580x326",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1575720695190145063/original.png?1502724355",
        fileSize: "389303",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1575720695190145063/small.png?1502724355",
        createdAt: "2017-08-14T15:25:56Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1NzU3MjEwNjkxNjQ1MTU3OTg=",
        name: "Amenities2-580x326",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1575721069164515798/original.png?1502724712",
        fileSize: "251083",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1575721069164515798/small.png?1502724712",
        createdAt: "2017-08-14T15:31:53Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1NzU3MjEwOTI4MTE5Njc4Nzk=",
        name: "AmenitiesNew3B-580x326",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1575721092811967879/original.png?1502724735",
        fileSize: "349727",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1575721092811967879/small.png?1502724735",
        createdAt: "2017-08-14T15:32:16Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1NzU3MjExNjMyODI0MTI0NjQ=",
        name: "AmenitiesNew1-580x326",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1575721163282412464/original.png?1502724802",
        fileSize: "445841",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1575721163282412464/small.png?1502724802",
        createdAt: "2017-08-14T15:33:23Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1NzU3MjI2MTI1OTczNjIzMDg=",
        name: "IntroTeam-580x326",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1575722612597362308/original.png?1502726184",
        fileSize: "275096",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1575722612597362308/small.png?1502726184",
        createdAt: "2017-08-14T15:56:25Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1NzU3MjM2NzMwNzkxODYzNDA=",
        name: "General_Announcement1-580x326",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1575723673079186340/original.png?1502727195",
        fileSize: "410196",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1575723673079186340/small.png?1502727195",
        createdAt: "2017-08-14T16:13:16Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1ODI5NzYwMzIwNTE5MzMwMTg=",
        name: "small",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1582976032051933018/original.png?1509643584",
        fileSize: "362091",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1582976032051933018/small.png?1509643584",
        createdAt: "2017-11-02T17:26:25Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1ODM2OTY0NTgzMzYzMDc5OTg=",
        name: "AdobeStock_9525053",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1583696458336307998/original.jpeg?1510330635",
        fileSize: "1090040",
        fileType: "JPEG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1583696458336307998/small.jpeg?1510330635",
        createdAt: "2017-11-10T16:17:17Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1ODM2OTY2MTIwNjM0NjU3MDU=",
        name: "AdobeStock_3120383",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1583696612063465705/original.jpeg?1510330782",
        fileSize: "1533465",
        fileType: "JPEG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1583696612063465705/small.jpeg?1510330782",
        createdAt: "2017-11-10T16:19:43Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1ODQwNjU3MzA1MTc3OTUwMTk=",
        name: "AdobeStock_58505406_Preview",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1584065730517795019/original.jpeg?1510682801",
        fileSize: "146533",
        fileType: "JPEG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1584065730517795019/small.jpeg?1510682801",
        createdAt: "2017-11-14T18:06:42Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1ODYyNDgwMTI0NDUxNDI4MDA=",
        name: "2017-12-08_15-10-00",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1586248012445142800/original.png?1512763988",
        fileSize: "118840",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1586248012445142800/small.png?1512763988",
        createdAt: "2017-12-08T20:13:08Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1OTAzMTc0OTU5ODE3OTA1MDI=",
        name: "Bozzuto-logo-147x45",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1590317495981790502/original.png?1516644949",
        fileSize: "2953",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1590317495981790502/small.png?1516644949",
        createdAt: "2018-01-22T18:15:50Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1OTE2MDMyOTAzNzgxMjk2NTM=",
        name: "Right_Image",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1591603290378129653/original.png?1517871178",
        fileSize: "143957",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1591603290378129653/small.png?1517871178",
        createdAt: "2018-02-05T22:52:59Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1OTE2MDM4Mjg2ODM3NzgxNDY=",
        name: "Left_Image",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1591603828683778146/original.png?1517871692",
        fileSize: "193756",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1591603828683778146/small.png?1517871692",
        createdAt: "2018-02-05T23:01:33Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1OTE4NTEzMTcyNTAxOTI1NjI=",
        name: "scott-warman-525554",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1591851317250192562/original.jpg?1518107714",
        fileSize: "1367992",
        fileType: "JPEG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1591851317250192562/small.jpg?1518107714",
        createdAt: "2018-02-08T16:35:16Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1OTE4NTEzOTU2MDg1MDA3MTk=",
        name: "scott-warman-525554",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1591851395608500719/original.jpg?1518107787",
        fileSize: "1367992",
        fileType: "JPEG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1591851395608500719/small.jpg?1518107787",
        createdAt: "2018-02-08T16:36:31Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1OTE5NTYzNjY3NjM4MTExMTE=",
        name: "amenities-1",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1591956366763811111/original.png?1518207897",
        fileSize: "294625",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1591956366763811111/small.png?1518207897",
        createdAt: "2018-02-09T20:24:59Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1OTE5NTY1NDYzMjg2MzA4MTg=",
        name: "amenities-2",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1591956546328630818/original.png?1518208068",
        fileSize: "387853",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1591956546328630818/small.png?1518208068",
        createdAt: "2018-02-09T20:27:51Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1OTE5NTY4MTUwODMwMDk0Njk=",
        name: "amenities-3",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1591956815083009469/original.png?1518208326",
        fileSize: "415294",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1591956815083009469/small.png?1518208326",
        createdAt: "2018-02-09T20:32:07Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1OTE5NTcyNjk4NDUwNjMxOTY=",
        name: "features-1",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1591957269845063196/original.png?1518208759",
        fileSize: "415340",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1591957269845063196/small.png?1518208759",
        createdAt: "2018-02-09T20:39:21Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1OTE5NTc3MDA3Mzg0MDMwOTg=",
        name: "features-2",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1591957700738403098/original.png?1518209170",
        fileSize: "246746",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1591957700738403098/small.png?1518209170",
        createdAt: "2018-02-09T20:46:11Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1OTE5NTg2MTQ1NzY2ODYzNjk=",
        name: "neighborhood-dining-1",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1591958614576686369/original.png?1518210042",
        fileSize: "418048",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1591958614576686369/small.png?1518210042",
        createdAt: "2018-02-09T21:00:43Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1OTE5NTkzMDM4MTIxMTExMzU=",
        name: "neighborhood-shopping",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1591959303812111135/original.png?1518210699",
        fileSize: "436120",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1591959303812111135/small.png?1518210699",
        createdAt: "2018-02-09T21:11:40Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1OTE5NjA3ODQxNjIwODI5NDY=",
        name: "neighborhood-entertainment",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1591960784162082946/original.png?1518212110",
        fileSize: "391021",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1591960784162082946/small.png?1518212110",
        createdAt: "2018-02-09T21:35:12Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1OTE5NjIwNjI3NzgyNzg3NDE=",
        name: "thank-you-for-touring",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1591962062778278741/original.png?1518213330",
        fileSize: "404091",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1591962062778278741/small.png?1518213330",
        createdAt: "2018-02-09T21:55:31Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1OTE5NjI3MDIzMTE5NzYwODM=",
        name: "still-intereted",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1591962702311976083/original.png?1518213939",
        fileSize: "232882",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1591962702311976083/small.png?1518213939",
        createdAt: "2018-02-09T22:05:41Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1OTE5NjYxMzQyMjM5NDI3ODY=",
        name: "still-intereted-small-1",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1591966134223942786/original.png?1518217213",
        fileSize: "183253",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1591966134223942786/small.png?1518217213",
        createdAt: "2018-02-09T23:00:14Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1OTE5NjYxODA3MDUyMjU1Mjg=",
        name: "still-intereted-small-2",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1591966180705225528/original.png?1518217257",
        fileSize: "181916",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1591966180705225528/small.png?1518217257",
        createdAt: "2018-02-09T23:00:59Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1OTE5NjYyMTQ0OTMwNjUwNjU=",
        name: "still-intereted-small-3",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1591966214493065065/original.png?1518217289",
        fileSize: "169043",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1591966214493065065/small.png?1518217289",
        createdAt: "2018-02-09T23:01:31Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1OTE5NjYyNDU4MTM5MTIxOTY=",
        name: "still-intereted-small-2",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1591966245813912196/original.png?1518217319",
        fileSize: "181916",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1591966245813912196/small.png?1518217319",
        createdAt: "2018-02-09T23:02:01Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1OTIyMDY0ODgzNzA2NDcxNzg=",
        name: "still-interested-yes",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1592206488370647178/original.png?1518446433",
        fileSize: "5384",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1592206488370647178/small.png?1518446433",
        createdAt: "2018-02-12T14:40:34Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1OTIyMDY1MDQ3MDc5ODcwMjg=",
        name: "still-interested-no",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1592206504707987028/original.png?1518446449",
        fileSize: "6853",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1592206504707987028/small.png?1518446449",
        createdAt: "2018-02-12T14:40:49Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1OTIyMDY1NDM4ODUzNTI5MDM=",
        name: "still-interested-no",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1592206543885352903/original.png?1518446486",
        fileSize: "5940",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1592206543885352903/small.png?1518446486",
        createdAt: "2018-02-12T14:41:27Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1OTIyMDg0Njg1NzQ0MjE0NzA=",
        name: "missed-you-splash",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1592208468574421470/original.png?1518448321",
        fileSize: "415340",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1592208468574421470/small.png?1518448321",
        createdAt: "2018-02-12T15:12:02Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1OTIyMDk4OTEyMzQxNzI5NzI=",
        name: "missed-you-studio",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1592209891234172972/original.png?1518449678",
        fileSize: "3099",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1592209891234172972/small.png?1518449678",
        createdAt: "2018-02-12T15:34:39Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1OTIyMDk5MDk1MzMwMDc2MDM=",
        name: "missed-you-1bedroom",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1592209909533007603/original.png?1518449696",
        fileSize: "4054",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1592209909533007603/small.png?1518449696",
        createdAt: "2018-02-12T15:34:57Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1OTIyMTAyMjIyNjU0NTE1MTI=",
        name: "missed-you-2bedroom",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1592210222265451512/original.png?1518449994",
        fileSize: "4283",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1592210222265451512/small.png?1518449994",
        createdAt: "2018-02-12T15:39:55Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1OTIyMTAyNDAxODQyMzM2MTk=",
        name: "missed-you-contact",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1592210240184233619/original.png?1518450011",
        fileSize: "3275",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1592210240184233619/small.png?1518450011",
        createdAt: "2018-02-12T15:40:12Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1OTIyMTE4ODE2NTQyODc3MTk=",
        name: "missed-you-small-1",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1592211881654287719/original.png?1518451576",
        fileSize: "166322",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1592211881654287719/small.png?1518451576",
        createdAt: "2018-02-12T16:06:17Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1OTIyMTIxMzc3ODcyMTU1ODY=",
        name: "missed-you-small-2",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1592212137787215586/original.png?1518451820",
        fileSize: "190544",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1592212137787215586/small.png?1518451820",
        createdAt: "2018-02-12T16:10:22Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1OTIyMTMxMDQ2NDI5NzI0MzU=",
        name: "timed-offer-splash",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1592213104642972435/original.png?1518452743",
        fileSize: "263054",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1592213104642972435/small.png?1518452743",
        createdAt: "2018-02-12T16:25:44Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1OTIyMTQ0NDU5MjY4MjU4NTc=",
        name: "welcome-resident-basic-info-splash",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1592214445926825857/original.png?1518454020",
        fileSize: "400026",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1592214445926825857/small.png?1518454020",
        createdAt: "2018-02-12T16:47:03Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1OTIyMTYzOTA1NDYzMzc5MzM=",
        name: "welcome-resident-services",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1592216390546337933/original.png?1518455876",
        fileSize: "430497",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1592216390546337933/small.png?1518455876",
        createdAt: "2018-02-12T17:17:57Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1OTIzMTc4MTU5NTc4NzQxNzE=",
        name: "still-interested-yes",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1592317815957874171/original.png?1518552602",
        fileSize: "3859",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1592317815957874171/small.png?1518552602",
        createdAt: "2018-02-13T20:10:04Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1OTIzMTc4NTEyNzMzNTg2NDg=",
        name: "still-interested-no",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1592317851273358648/original.png?1518552637",
        fileSize: "4618",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1592317851273358648/small.png?1518552637",
        createdAt: "2018-02-13T20:10:38Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1OTIzMTg2NzQ2NzQzNzcwOTI=",
        name: "still-interested-yes",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1592318674674377092/original.png?1518553421",
        fileSize: "2788",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1592318674674377092/small.png?1518553421",
        createdAt: "2018-02-13T20:23:43Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1OTIzMTg2OTAwMzM2NzI2OTg=",
        name: "still-interested-no",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1592318690033672698/original.png?1518553437",
        fileSize: "2837",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1592318690033672698/small.png?1518553437",
        createdAt: "2018-02-13T20:23:58Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1OTIzMTg4NjU4Mzk2MzI2NjQ=",
        name: "missed-you-studio",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1592318865839632664/original.png?1518553604",
        fileSize: "3084",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1592318865839632664/small.png?1518553604",
        createdAt: "2018-02-13T20:26:45Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1OTIzMTg4ODAyODA2MzQ4NTk=",
        name: "missed-you-1bedroom",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1592318880280634859/original.png?1518553618",
        fileSize: "3415",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1592318880280634859/small.png?1518553618",
        createdAt: "2018-02-13T20:26:59Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1OTIzMTg5MjA4NDAzMzU2NzQ=",
        name: "missed-you-2bedroom",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1592318920840335674/original.png?1518553656",
        fileSize: "3551",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1592318920840335674/small.png?1518553656",
        createdAt: "2018-02-13T20:27:38Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1OTIzMTg5MzQxNTI5MTQyODQ=",
        name: "missed-you-contact",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1592318934152914284/original.png?1518553669",
        fileSize: "2468",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1592318934152914284/small.png?1518553669",
        createdAt: "2018-02-13T20:27:51Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1OTIzMjU5NjY5NDU5MDExNzY=",
        name: "2AdobeStock_80268354_Preview",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1592325966945901176/original.png?1518560376",
        fileSize: "893714",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1592325966945901176/small.png?1518560376",
        createdAt: "2018-02-13T22:19:38Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1OTU2NzMwNzU1MDIwNjQzMTA=",
        name: "2",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1595673075502064310/original.jpg?1521752427",
        fileSize: "2328",
        fileType: "JPEG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1595673075502064310/small.jpg?1521752427",
        createdAt: "2018-03-22T21:00:29Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1OTgyMDcwNDEwNDk2ODkyNTc=",
        name: "avenueatyork-renewlease",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1598207041049689257/original.png?1524169005",
        fileSize: "304325",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1598207041049689257/small.png?1524169005",
        createdAt: "2018-04-19T20:16:47Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1OTgyMDc4NDI1NDQwNzMwOTE=",
        name: "avenueatyork-renewleaseoffer",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1598207842544073091/original.png?1524169766",
        fileSize: "510802",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1598207842544073091/small.png?1524169766",
        createdAt: "2018-04-19T20:29:31Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1OTgyMDk1OTYyNjYyOTM1ODk=",
        name: "avenueatyork-noticeday",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1598209596266293589/original.png?1524171442",
        fileSize: "411066",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1598209596266293589/small.png?1524171442",
        createdAt: "2018-04-19T20:57:24Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1OTgyMTExMzY5OTI5NjI0NzI=",
        name: "avenueatyork-moveoutchecklist",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1598211136992962472/original.png?1524172911",
        fileSize: "268008",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1598211136992962472/small.png?1524172911",
        createdAt: "2018-04-19T21:21:53Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1OTgyOTAxNDE5NjAyNjY0NzY=",
        name: "avenueatyork-friendreferral",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1598290141960266476/original.png?1524248257",
        fileSize: "298674",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1598290141960266476/small.png?1524248257",
        createdAt: "2018-04-20T18:17:38Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1OTgyOTIxNjY5NjA3OTQ0Mzk=",
        name: "avenueatyork-optionreferral",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1598292166960794439/original.png?1524250187",
        fileSize: "405728",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1598292166960794439/small.png?1524250187",
        createdAt: "2018-04-20T18:49:49Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1OTgyOTM4MDM1NjU0MTQxMTA=",
        name: "avenueatyork-birthday",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1598293803565414110/original.png?1524251749",
        fileSize: "339253",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1598293803565414110/small.png?1524251749",
        createdAt: "2018-04-20T19:15:50Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1OTgyOTM5MjIzMTE0MjUzNjQ=",
        name: "avenueatyork-friendreferral",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1598293922311425364/original.png?1524251862",
        fileSize: "298674",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1598293922311425364/small.png?1524251862",
        createdAt: "2018-04-20T19:17:43Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1OTgyOTQxMjM1ODc1ODY3NDU=",
        name: "avenueatyork-optionreferral",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1598294123587586745/original.png?1524252054",
        fileSize: "405728",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1598294123587586745/small.png?1524252054",
        createdAt: "2018-04-20T19:20:55Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1OTgyOTQyOTMxNTYyODg0NjU=",
        name: "avenueatyork-birthday",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1598294293156288465/original.png?1524252216",
        fileSize: "339253",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1598294293156288465/small.png?1524252216",
        createdAt: "2018-04-20T19:23:37Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1OTgyOTY4MDk3OTMxODQ2MDg=",
        name: "avenueatyork-approvedapplication",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1598296809793184608/original.png?1524254616",
        fileSize: "192316",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1598296809793184608/small.png?1524254616",
        createdAt: "2018-04-20T20:03:37Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1OTgyOTc3NzgwNjYwNTM0Mzc=",
        name: "avenueatyork-moveinchecklist",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1598297778066053437/original.png?1524255539",
        fileSize: "302416",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1598297778066053437/small.png?1524255539",
        createdAt: "2018-04-20T20:19:00Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE2MDQ4OTU2NzE1NTk2OTMxMzY=",
        name: "original",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1604895671559693136/original.png?1530547781",
        fileSize: "352580",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1604895671559693136/small.png?1530547781",
        createdAt: "2018-07-02T16:09:42Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE2MDQ4OTU4MjE3NzIwODM5Njc=",
        name: "Feature_Image",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1604895821772083967/original.png?1530547923",
        fileSize: "396578",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1604895821772083967/small.png?1530547923",
        createdAt: "2018-07-02T16:12:05Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE2MDQ4OTU4OTg4NDUxNDIwMTM=",
        name: "original",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1604895898845142013/original.png?1530547997",
        fileSize: "409901",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1604895898845142013/small.png?1530547997",
        createdAt: "2018-07-02T16:13:19Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE2MDQ4OTkyODU0Mjc4Mzk5Mjc=",
        name: "Feature_Image",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1604899285427839927/original.png?1530551227",
        fileSize: "214204",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1604899285427839927/small.png?1530551227",
        createdAt: "2018-07-02T17:07:08Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE2MDQ5MDEyNTM0NzIzNDg5NDY=",
        name: "Feature_Image",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1604901253472348946/original.png?1530553104",
        fileSize: "478839",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1604901253472348946/small.png?1530553104",
        createdAt: "2018-07-02T17:38:25Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE2MDQ5MDE3OTE4ODc5MzUxMDM=",
        name: "Feature_Image",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1604901791887935103/original.png?1530553617",
        fileSize: "405304",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1604901791887935103/small.png?1530553617",
        createdAt: "2018-07-02T17:46:59Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE2MDQ5MDE4OTIwODY0NDIwMTg=",
        name: "Feature_Image",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1604901892086442018/original.png?1530553713",
        fileSize: "346280",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1604901892086442018/small.png?1530553713",
        createdAt: "2018-07-02T17:48:34Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE2MDQ5MDIwMjMwNDUxMjQ2MTE=",
        name: "Feature_Image",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1604902023045124611/original.png?1530553838",
        fileSize: "355738",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1604902023045124611/small.png?1530553838",
        createdAt: "2018-07-02T17:50:39Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE2MDQ5MDI3MTE0ODQ2MjkxNjE=",
        name: "Feature_Image",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1604902711484629161/original.png?1530554495",
        fileSize: "346280",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1604902711484629161/small.png?1530554495",
        createdAt: "2018-07-02T18:01:36Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE2MDQ5MDM1MjU5NDIzMzgyMDk=",
        name: "Feature_Image",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1604903525942338209/original.png?1530555271",
        fileSize: "352372",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1604903525942338209/small.png?1530555271",
        createdAt: "2018-07-02T18:14:32Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE2MDQ5MDQ2MDY4MDkxMzY4NDE=",
        name: "Feature_Image",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1604904606809136841/original.png?1530556302",
        fileSize: "320791",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1604904606809136841/small.png?1530556302",
        createdAt: "2018-07-02T18:31:43Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE2MDQ5MDQ2NTYyNjM4NTA3NDE=",
        name: "Feature_Image",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1604904656263850741/original.png?1530556349",
        fileSize: "382680",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1604904656263850741/small.png?1530556349",
        createdAt: "2018-07-02T18:32:30Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE2MDQ5MDQ3NjU1MTE1NDkxODE=",
        name: "Feature_Image",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1604904765511549181/original.png?1530556453",
        fileSize: "452712",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1604904765511549181/small.png?1530556453",
        createdAt: "2018-07-02T18:34:15Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE2MDQ5MDQ4ODI5MjQ2NjA4NzY=",
        name: "Feature_Image",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1604904882924660876/original.png?1530556564",
        fileSize: "381399",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1604904882924660876/small.png?1530556564",
        createdAt: "2018-07-02T18:36:07Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE2MDQ5MDUwMzUwNDM5ODI0MzQ=",
        name: "Feature_Image",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1604905035043982434/original.png?1530556710",
        fileSize: "301177",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1604905035043982434/small.png?1530556710",
        createdAt: "2018-07-02T18:38:32Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE2MDQ5MDU3MzU2OTM1MzQ3NDQ=",
        name: "Feature_Image",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1604905735693534744/original.png?1530557379",
        fileSize: "301063",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1604905735693534744/small.png?1530557379",
        createdAt: "2018-07-02T18:49:40Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE2MDQ5MDk5MDk5ODUzNzUwNjQ=",
        name: "Feature_Image",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1604909909985375064/original.png?1530561359",
        fileSize: "415930",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1604909909985375064/small.png?1530561359",
        createdAt: "2018-07-02T19:56:01Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE2MDQ5MTQ1ODQwOTU5MzEwNDI=",
        name: "Feature_Image",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1604914584095931042/original.png?1530565815",
        fileSize: "264243",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1604914584095931042/small.png?1530565815",
        createdAt: "2018-07-02T21:10:18Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE2MDQ5MTYzNjI1MDA5MzMzNTA=",
        name: "Feature_Image",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1604916362500933350/original.png?1530567513",
        fileSize: "299385",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1604916362500933350/small.png?1530567513",
        createdAt: "2018-07-02T21:38:34Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE2MDQ5MTY5MDYxMjg1NDkyNzU=",
        name: "Feature_Image",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1604916906128549275/original.png?1530568032",
        fileSize: "411940",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1604916906128549275/small.png?1530568032",
        createdAt: "2018-07-02T21:47:13Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE2MDQ5MTc4NzE0ODAyODI2NTA=",
        name: "Feature_Image",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1604917871480282650/original.png?1530568952",
        fileSize: "475197",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1604917871480282650/small.png?1530568952",
        createdAt: "2018-07-02T22:02:33Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE2MDQ5MTg0MTQzMTQxMzM1NTE=",
        name: "original",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1604918414314133551/original.png?1530569470",
        fileSize: "398966",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1604918414314133551/small.png?1530569470",
        createdAt: "2018-07-02T22:11:11Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE2MDQ5MTg3NjU4MzY4MDM5NTY=",
        name: "Feature_Image",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1604918765836803956/original.png?1530569805",
        fileSize: "387507",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1604918765836803956/small.png?1530569805",
        createdAt: "2018-07-02T22:16:46Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE2MDQ5MTg4NzQ3ODUwNjc5MDM=",
        name: "Feature_Image",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1604918874785067903/original.png?1530569909",
        fileSize: "391931",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1604918874785067903/small.png?1530569909",
        createdAt: "2018-07-02T22:18:30Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE2MDQ5MTkyNTk3MjIyNjc4MjM=",
        name: "Feature_Image",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1604919259722267823/original.png?1530570276",
        fileSize: "353872",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1604919259722267823/small.png?1530570276",
        createdAt: "2018-07-02T22:24:37Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE2MDQ5MTk1ODA3NjExNjQ5MTk=",
        name: "original",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1604919580761164919/original.png?1530570582",
        fileSize: "304471",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1604919580761164919/small.png?1530570582",
        createdAt: "2018-07-02T22:29:44Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE2MDQ5MTk5OTIxNDYxNDA3ODE=",
        name: "Feature_Image",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1604919992146140781/original.png?1530570974",
        fileSize: "262636",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1604919992146140781/small.png?1530570974",
        createdAt: "2018-07-02T22:36:16Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE2MDQ5MjAxODY4OTU2MDE2MDY=",
        name: "Feature_Image",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1604920186895601606/original.png?1530571160",
        fileSize: "333964",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1604920186895601606/small.png?1530571160",
        createdAt: "2018-07-02T22:39:22Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE2MDQ5OTczNzM4MzA1NTU2OTc=",
        name: "original",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1604997373830555697/original.png?1530644772",
        fileSize: "359100",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1604997373830555697/small.png?1530644772",
        createdAt: "2018-07-03T19:06:13Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE2MDQ5OTg0NTUxMzYwMDAwMTc=",
        name: "Feature_Image",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1604998455136000017/original.png?1530645802",
        fileSize: "221153",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1604998455136000017/small.png?1530645802",
        createdAt: "2018-07-03T19:23:24Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE2MDQ5OTg3Mjk5NzQwMzAzMjU=",
        name: "original",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1604998729974030325/original.png?1530646065",
        fileSize: "381820",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1604998729974030325/small.png?1530646065",
        createdAt: "2018-07-03T19:27:46Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE2MDQ5OTg3ODU2OTc1Nzc1NDI=",
        name: "original",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1604998785697577542/original.png?1530646118",
        fileSize: "380458",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1604998785697577542/small.png?1530646118",
        createdAt: "2018-07-03T19:28:39Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE2MDQ5OTkwODU2MjMxMjk4MjA=",
        name: "Feature_Image",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1604999085623129820/original.png?1530646404",
        fileSize: "400124",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1604999085623129820/small.png?1530646404",
        createdAt: "2018-07-03T19:33:25Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE2MDQ5OTkxMDQ0MDk0NDczMzA=",
        name: "original",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1604999104409447330/original.png?1530646421",
        fileSize: "302219",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1604999104409447330/small.png?1530646421",
        createdAt: "2018-07-03T19:33:43Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE2MDUwMDAwMTkxNjk5NjUwMzY=",
        name: "Feature_Image",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1605000019169965036/original.png?1530647294",
        fileSize: "310307",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1605000019169965036/small.png?1530647294",
        createdAt: "2018-07-03T19:48:16Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE2MDUwMDAzMjg0MTU0OTA0NjI=",
        name: "Feature_Image",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1605000328415490462/original.png?1530647589",
        fileSize: "340992",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1605000328415490462/small.png?1530647589",
        createdAt: "2018-07-03T19:53:11Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE2MDUwMDA2OTA3NjAzMjI4ODk=",
        name: "Feature_Image",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1605000690760322889/original.png?1530647935",
        fileSize: "477042",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1605000690760322889/small.png?1530647935",
        createdAt: "2018-07-03T19:58:56Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE2MDUwMDA5NzYzNjI3MTc0NzU=",
        name: "Feature_Image",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1605000976362717475/original.png?1530648207",
        fileSize: "284845",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1605000976362717475/small.png?1530648207",
        createdAt: "2018-07-03T20:03:28Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE2MDUwMDE2NTA0Mzk4MjUxNjQ=",
        name: "Feature_Image",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1605001650439825164/original.png?1530648850",
        fileSize: "450209",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1605001650439825164/small.png?1530648850",
        createdAt: "2018-07-03T20:14:11Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE2MDUwMDIwNjUwODgwNjM0NzM=",
        name: "original",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1605002065088063473/original.png?1530649244",
        fileSize: "399046",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1605002065088063473/small.png?1530649244",
        createdAt: "2018-07-03T20:20:47Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE2MDUwMDg0MTA2Nzg5NjQxNTg=",
        name: "Feature_Image",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1605008410678964158/original.png?1530655297",
        fileSize: "412189",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1605008410678964158/small.png?1530655297",
        createdAt: "2018-07-03T22:01:38Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE2MDUwMDg3NzA2MjkyOTQ4NzE=",
        name: "original",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1605008770629294871/original.png?1530655640",
        fileSize: "330178",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1605008770629294871/small.png?1530655640",
        createdAt: "2018-07-03T22:07:22Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE2MTUzMzc5OTgyNDQ2NDI1NDU=",
        name: "Feature_Image",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1615337998244642545/original.png?1540506359",
        fileSize: "430559",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1615337998244642545/small.png?1540506359",
        createdAt: "2018-10-25T22:26:01Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE2MjYwNjQ5MTE1NTY0NDY5NDg=",
        name: "2018-01-30_11-16-53",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1626064911556446948/original.png?1550736342",
        fileSize: "143153",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1626064911556446948/small.png?1550736342",
        createdAt: "2019-02-21T08:05:42Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE2MjYwOTEzMDA2NjYzNDI2NzU=",
        name: "grey",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1626091300666342675/original.png?1550761509",
        fileSize: "172011",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1626091300666342675/small.png?1550761509",
        createdAt: "2019-02-21T15:05:09Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE2MjYwOTIwNTY2ODE5NDg3ODI=",
        name: "bookcover",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1626092056681948782/original.png?1550762230",
        fileSize: "316929",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1626092056681948782/small.png?1550762230",
        createdAt: "2019-02-21T15:17:10Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE2Mjk3MzY4NDUwMDkzMTk3MjM=",
        name: "Feature_Image",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1629736845009319723/original.png?1554238171",
        fileSize: "178573",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1629736845009319723/small.png?1554238171",
        createdAt: "2019-04-02T20:49:31Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE2Mzc1MDcxMzQzMjM3MjkyNjk=",
        name: "Awesome_Image",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1637507134323729269/original.png?1561648496",
        fileSize: "8691",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1637507134323729269/small.png?1561648496",
        createdAt: "2019-06-27T15:14:56Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE2Mzc1MTA5NjI4MTMyNTAwMjI=",
        name: "Awesome_Image",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1637510962813250022/original.png?1561652147",
        fileSize: "22591",
        fileType: "JPEG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1637510962813250022/small.png?1561652147",
        createdAt: "2019-06-27T16:15:48Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE2Mzc1MTEzNTc4NDkzOTgxMDc=",
        name: "Awesome_Image",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1637511357849398107/original.png?1561652524",
        fileSize: "35144",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1637511357849398107/small.png?1561652524",
        createdAt: "2019-06-27T16:22:04Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE2Mzc1MTE2NjUzNTcxODc2MDU=",
        name: "Awesome_Image",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1637511665357187605/original.png?1561652818",
        fileSize: "24455",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1637511665357187605/small.png?1561652818",
        createdAt: "2019-06-27T16:26:58Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE2Mzc1MTM4ODM5ODkzOTQ3ODE=",
        name: "Selection_060",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1637513883989394781/original.png?1561654933",
        fileSize: "30511",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1637513883989394781/small.png?1561654933",
        createdAt: "2019-06-27T17:02:13Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE2Mzc3NjYxNzU0NzMxMjA2ODA=",
        name: "New-Years-eve",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1637766175473120680/original.jpg?1561895537",
        fileSize: "259085",
        fileType: "JPEG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1637766175473120680/small.jpg?1561895537",
        createdAt: "2019-06-30T11:52:17Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE2Mzc3NjY5NTI1Mjk5NTU2MzE=",
        name: "Labor-day",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1637766952529955631/original.jpg?1561896278",
        fileSize: "520606",
        fileType: "JPEG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1528252253585581240/library/1637766952529955631/small.jpg?1561896278",
        createdAt: "2019-06-30T12:04:38Z"
      }
    ]
  },
  {
    id: "TWt0Zzo6U2VjdGlvbi0xNTU4OTg5MDU2ODQ3NTczNTYx",
    name: "New Email Images",
    type: "Org",
    createdAt: "2017-02-10T23:03:43Z",
    hasMore: false,
    assets: [
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1NTg5ODkxMzY4MjM4ODI1MzM=",
        name: "NeighborhoodSpa_580x326",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1558989136823882533/original.png?1486767896",
        fileSize: "360240",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1558989136823882533/small.png?1486767896",
        createdAt: "2017-02-10T23:04:59Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1NTg5ODkxMzgxNTA4MTgyMTI=",
        name: "NeighborhoodClothing_580x326",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1558989138150818212/original.png?1486767898",
        fileSize: "377613",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1558989138150818212/small.png?1486767898",
        createdAt: "2017-02-10T23:05:00Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1NTg5ODkxMzkyMDQyMTExODA=",
        name: "ReferAFriend1_580x326",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1558989139204211180/original.png?1486767899",
        fileSize: "419423",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1558989139204211180/small.png?1486767899",
        createdAt: "2017-02-10T23:05:01Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1NTg5ODkxNDE0ODQzNjU1MDI=",
        name: "ReferAFriend2_580x326",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1558989141484365502/original.png?1486767901",
        fileSize: "289580",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1558989141484365502/small.png?1486767901",
        createdAt: "2017-02-10T23:05:03Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1NTg5ODkxNTI2MTIxMTcwOTM=",
        name: "EasterEggHunt_580x326",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1558989152612117093/original.png?1486767907",
        fileSize: "377873",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1558989152612117093/small.png?1486767907",
        createdAt: "2017-02-10T23:05:14Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1NTg5ODkxNTY4ODA4OTA5NTM=",
        name: "FeatureImgSmall_580x285",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1558989156880890953/original.png?1486767908",
        fileSize: "321941",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1558989156880890953/small.png?1486767908",
        createdAt: "2017-02-10T23:05:18Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1NTg5ODkxNjIyMTAwNDg2Mzc=",
        name: "ValentinesDayLarge_580x326",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1558989162210048637/original.png?1486767914",
        fileSize: "332827",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1558989162210048637/small.png?1486767914",
        createdAt: "2017-02-10T23:05:23Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1NTg5ODkxNjI1MTM4Nzk1NzA=",
        name: "NeighborhoodCoffee_580x326",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1558989162513879570/original.png?1486767912",
        fileSize: "306415",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1558989162513879570/small.png?1486767912",
        createdAt: "2017-02-10T23:05:23Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1NTg5ODkxNjI2OTk5MzY1ODc=",
        name: "Halloween_580x326",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1558989162699936587/original.png?1486767915",
        fileSize: "370067",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1558989162699936587/small.png?1486767915",
        createdAt: "2017-02-10T23:05:24Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1NTg5ODkxNjM4NjI0ODIxODQ=",
        name: "SplashImageLeft_285x285",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1558989163862482184/original.png?1486767918",
        fileSize: "99448",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1558989163862482184/small.png?1486767918",
        createdAt: "2017-02-10T23:05:25Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1NTg5ODkxNjk0MDMwNDUwMDM=",
        name: "SplashImageRight_285x285",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1558989169403045003/original.png?1486767925",
        fileSize: "95919",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1558989169403045003/small.png?1486767925",
        createdAt: "2017-02-10T23:05:30Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1NTg5ODkxNjk0NjYyMjI0NTc=",
        name: "NewYearsEve_580x326",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1558989169466222457/original.png?1486767924",
        fileSize: "385707",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1558989169466222457/small.png?1486767924",
        createdAt: "2017-02-10T23:05:30Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1NTg5ODkxNzkxNTE3NDgwODc=",
        name: "4thOfJuly_580x326",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1558989179151748087/original.png?1486767934",
        fileSize: "420278",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1558989179151748087/small.png?1486767934",
        createdAt: "2017-02-10T23:05:39Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1NTg5ODkxODQwMTUyMTA4NzM=",
        name: "ValentinesDaySmall1_285x285",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1558989184015210873/original.png?1486767942",
        fileSize: "122919",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1558989184015210873/small.png?1486767942",
        createdAt: "2017-02-10T23:05:44Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1NTg5ODkxODQ5MjQzNDE2MTc=",
        name: "StPatricksDay_580x326",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1558989184924341617/original.png?1486767943",
        fileSize: "386434",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1558989184924341617/small.png?1486767943",
        createdAt: "2017-02-10T23:05:45Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1NTg5ODkxODg1OTM1NzQwODE=",
        name: "Superbowl_580x326",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1558989188593574081/original.png?1486767946",
        fileSize: "465642",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1558989188593574081/small.png?1486767946",
        createdAt: "2017-02-10T23:05:48Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1NTg5ODkxODk4NDI5ODUzNjU=",
        name: "Thanksgiving_580x326",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1558989189842985365/original.png?1486767948",
        fileSize: "361224",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1558989189842985365/small.png?1486767948",
        createdAt: "2017-02-10T23:05:49Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1NTg5ODkxOTM4OTQ3NTAwOTE=",
        name: "ValentinesDaySmall2_285x285",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1558989193894750091/original.png?1486767952",
        fileSize: "127009",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1558989193894750091/small.png?1486767952",
        createdAt: "2017-02-10T23:05:53Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1NTg5ODkxOTU5NjY5ODIxODg=",
        name: "IntroNeighborhood_580x326",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1558989195966982188/original.png?1486767953",
        fileSize: "299971",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1558989195966982188/small.png?1486767953",
        createdAt: "2017-02-10T23:05:55Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1NTg5ODkxOTk0MjcwOTM0Mzg=",
        name: "Amenities2_580x326",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1558989199427093438/original.png?1486767957",
        fileSize: "226680",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1558989199427093438/small.png?1486767957",
        createdAt: "2017-02-10T23:05:59Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1NTg5ODkyMDEwNDc0NTM0MDc=",
        name: "Amenities1_580x326",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1558989201047453407/original.png?1486767958",
        fileSize: "448014",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1558989201047453407/small.png?1486767958",
        createdAt: "2017-02-10T23:06:00Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1NTg5ODkyMDM4NDA3Njc5MDI=",
        name: "General_Announcement3_580x326",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1558989203840767902/original.png?1486767959",
        fileSize: "340139",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1558989203840767902/small.png?1486767959",
        createdAt: "2017-02-10T23:06:03Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1NTg5ODkyMDQzMDI5NjI5NTY=",
        name: "General_Announcement2_580x326",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1558989204302962956/original.png?1486767959",
        fileSize: "410036",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1558989204302962956/small.png?1486767959",
        createdAt: "2017-02-10T23:06:03Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1NTg5ODkyMDU0OTEzNDkyNjM=",
        name: "IntroTeam_580x326",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1558989205491349263/original.png?1486767961",
        fileSize: "199114",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1558989205491349263/small.png?1486767961",
        createdAt: "2017-02-10T23:06:04Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1NTg5ODkyMDg2NjA4MzQwMDQ=",
        name: "Amenities3_580x326",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1558989208660834004/original.png?1486767964",
        fileSize: "462891",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1558989208660834004/small.png?1486767964",
        createdAt: "2017-02-10T23:06:07Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1NTg5ODkyMDk5NTY2MDI0MzE=",
        name: "General_Announcement1_580x326",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1558989209956602431/original.png?1486767964",
        fileSize: "399322",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1558989209956602431/small.png?1486767964",
        createdAt: "2017-02-10T23:06:09Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1NTg5OTAwMjYxMTQ3NjAwOTE=",
        name: "ScheduleATour_(580x326)",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1558990026114760091/original.png?1486768744",
        fileSize: "301021",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1558990026114760091/small.png?1486768744",
        createdAt: "2017-02-10T23:19:07Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1NjE5MzE2OTI4NjUyNTgwNDA=",
        name: "ScheduleATour_(580x326)_v2",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1561931692865258040/original.png?1489574138",
        fileSize: "307916",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1561931692865258040/small.png?1489574138",
        createdAt: "2017-03-15T10:35:39Z"
      }
    ]
  },
  {
    id: "TWt0Zzo6U2VjdGlvbi0xNTMxNTI1MjUzODY5MTUzNzY5",
    name: "Old Email Images",
    type: "Org",
    createdAt: "2016-04-13T19:38:19Z",
    hasMore: false,
    assets: [
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1Mjg1MzYwMjgxMTU2MTQwMTE=",
        name: "AVENUE_AT_YORK___LUXURY_APARTMENTS__Copy_3",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528536028115614011/original.png?1457725551",
        fileSize: "6308",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528536028115614011/small.png?1457725551",
        createdAt: "2016-03-11T19:45:51Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1Mjg1NDY2NDE1MTgwNzI1NjQ=",
        name: "template-1",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528546641518072564/original.png?1457735672",
        fileSize: "304193",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528546641518072564/small.png?1457735672",
        createdAt: "2016-03-11T22:34:33Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1Mjg1NDY2Njg2NjA2MzM0MDY=",
        name: "template-6",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528546668660633406/original.png?1457735698",
        fileSize: "206525",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528546668660633406/small.png?1457735698",
        createdAt: "2016-03-11T22:34:59Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1Mjg1NDY2OTMyMDQxMjEzNDA=",
        name: "template-5",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528546693204121340/original.png?1457735722",
        fileSize: "47336",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528546693204121340/small.png?1457735722",
        createdAt: "2016-03-11T22:35:22Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1Mjg1NDY3OTgyNzc1OTkzMzM=",
        name: "template-2",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528546798277599333/original.png?1457735822",
        fileSize: "355656",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528546798277599333/small.png?1457735822",
        createdAt: "2016-03-11T22:37:02Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1Mjg1NDY4MTg1NzY4ODcxMDU=",
        name: "template-1",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528546818576887105/original.png?1457735841",
        fileSize: "304193",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528546818576887105/small.png?1457735841",
        createdAt: "2016-03-11T22:37:22Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1Mjg1NDY4NDU4MTc5NDU5MTY=",
        name: "template-3",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528546845817945916/original.png?1457735867",
        fileSize: "76437",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528546845817945916/small.png?1457735867",
        createdAt: "2016-03-11T22:37:48Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1Mjg1NDY4NjUyNTI5NTYyNTc=",
        name: "template-4",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528546865252956257/original.png?1457735886",
        fileSize: "78206",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528546865252956257/small.png?1457735886",
        createdAt: "2016-03-11T22:38:06Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1Mjg3OTEwMDIxODc0NDkzMTE=",
        name: "event-invite",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528791002187449311/original.jpg?1457968713",
        fileSize: "177504",
        fileType: "JPEG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528791002187449311/small.jpg?1457968713",
        createdAt: "2016-03-14T15:18:33Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1Mjg3OTI1NTg3MjE1NDYyNTQ=",
        name: "Event-Invite-Template",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528792558721546254/original.png?1457970197",
        fileSize: "328108",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528792558721546254/small.png?1457970197",
        createdAt: "2016-03-14T15:43:18Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1Mjg3OTg2MzM3ODc5ODY5MzA=",
        name: "referral_hero",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528798633787986930/original.png?1457975991",
        fileSize: "348127",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528798633787986930/small.png?1457975991",
        createdAt: "2016-03-14T17:19:51Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1Mjg4MDA5MjMwMDc4Nzc2NzU=",
        name: "Schedule_a_Tour",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528800923007877675/original.png?1457978174",
        fileSize: "255305",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528800923007877675/small.png?1457978174",
        createdAt: "2016-03-14T17:56:15Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1Mjg4MDM0MzMzOTQxNjAwNzQ=",
        name: "template-1",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528803433394160074/original.png?1457980568",
        fileSize: "295387",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528803433394160074/small.png?1457980568",
        createdAt: "2016-03-14T18:36:09Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1Mjg4MDM0NTU2NzU1ODQwNjM=",
        name: "template-2",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528803455675584063/original.png?1457980589",
        fileSize: "340898",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528803455675584063/small.png?1457980589",
        createdAt: "2016-03-14T18:36:30Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1Mjg4MDM1NTg2NTUxODkwNjc=",
        name: "template-2",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528803558655189067/original.png?1457980687",
        fileSize: "265063",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528803558655189067/small.png?1457980687",
        createdAt: "2016-03-14T18:38:08Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1Mjg4MDM1ODAwODUwNDY3MDM=",
        name: "template-3",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528803580085046703/original.png?1457980708",
        fileSize: "76452",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528803580085046703/small.png?1457980708",
        createdAt: "2016-03-14T18:38:29Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1Mjg4MDM1OTkzMTA2MjQwNzg=",
        name: "template-4",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528803599310624078/original.png?1457980726",
        fileSize: "75520",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528803599310624078/small.png?1457980726",
        createdAt: "2016-03-14T18:38:47Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1Mjg4MDM2MzMxNTAwOTgxNDk=",
        name: "template-5",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528803633150098149/original.png?1457980758",
        fileSize: "47542",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528803633150098149/small.png?1457980758",
        createdAt: "2016-03-14T18:39:19Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1Mjg4MDM2NTU0MzMxODE4NDY=",
        name: "template-6",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528803655433181846/original.png?1457980780",
        fileSize: "198270",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528803655433181846/small.png?1457980780",
        createdAt: "2016-03-14T18:39:41Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1Mjg4MDM3MzQ0NTM3NDQxMTU=",
        name: "template-2",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528803734453744115/original.png?1457980855",
        fileSize: "265063",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528803734453744115/small.png?1457980855",
        createdAt: "2016-03-14T18:40:56Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1Mjg4MDM3NTEyNzAyNjczODM=",
        name: "template-3",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528803751270267383/original.png?1457980871",
        fileSize: "76452",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528803751270267383/small.png?1457980871",
        createdAt: "2016-03-14T18:41:12Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1Mjg4MDM3NjY1NzYyNTQ3NTc=",
        name: "template-4",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528803766576254757/original.png?1457980886",
        fileSize: "75520",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528803766576254757/small.png?1457980886",
        createdAt: "2016-03-14T18:41:27Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1Mjg4MDM3OTc5NDEwMTU1MTk=",
        name: "template-6",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528803797941015519/original.png?1457980916",
        fileSize: "198270",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528803797941015519/small.png?1457980916",
        createdAt: "2016-03-14T18:41:56Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1Mjg4MDQwMjg5NzY2NDY2MTQ=",
        name: "template-2",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528804028976646614/original.png?1457981136",
        fileSize: "265063",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528804028976646614/small.png?1457981136",
        createdAt: "2016-03-14T18:45:37Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1Mjg4MDQwNTEzODcyOTYwOTA=",
        name: "template-3",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528804051387296090/original.png?1457981157",
        fileSize: "76452",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528804051387296090/small.png?1457981157",
        createdAt: "2016-03-14T18:45:58Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1Mjg4MDQwNjc2OTQ0MzIwMjE=",
        name: "template-4",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528804067694432021/original.png?1457981173",
        fileSize: "75520",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528804067694432021/small.png?1457981173",
        createdAt: "2016-03-14T18:46:14Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1Mjg4MDQwODk0MTk0ODk5Nzk=",
        name: "template-5",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528804089419489979/original.png?1457981194",
        fileSize: "47542",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528804089419489979/small.png?1457981194",
        createdAt: "2016-03-14T18:46:34Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1Mjg4MDQxMDMzMTk2OTk4MjI=",
        name: "template-6",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528804103319699822/original.png?1457981207",
        fileSize: "198270",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528804103319699822/small.png?1457981207",
        createdAt: "2016-03-14T18:46:48Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1Mjg4MDQxMzY2NzUyNzQ0MTA=",
        name: "template-2",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528804136675274410/original.png?1457981238",
        fileSize: "265063",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528804136675274410/small.png?1457981238",
        createdAt: "2016-03-14T18:47:19Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1Mjg4MDQxNTEzOTEzNTQ0ODI=",
        name: "template-3",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528804151391354482/original.png?1457981252",
        fileSize: "76452",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528804151391354482/small.png?1457981252",
        createdAt: "2016-03-14T18:47:33Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1Mjg4MDQxNjgwNTM1MjY3NDE=",
        name: "template-4",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528804168053526741/original.png?1457981268",
        fileSize: "75520",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528804168053526741/small.png?1457981268",
        createdAt: "2016-03-14T18:47:49Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1Mjg4MDQxODkwMzg5ODczMjI=",
        name: "template-6",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528804189038987322/original.png?1457981288",
        fileSize: "198270",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528804189038987322/small.png?1457981288",
        createdAt: "2016-03-14T18:48:09Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1Mjg4MDQyMDQwNjYyMjcwODc=",
        name: "template-5",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528804204066227087/original.png?1457981303",
        fileSize: "47542",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528804204066227087/small.png?1457981303",
        createdAt: "2016-03-14T18:48:24Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1Mjg4MDQyNjAzMDU1NDM5Mzc=",
        name: "template-2",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528804260305543937/original.png?1457981356",
        fileSize: "265063",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528804260305543937/small.png?1457981356",
        createdAt: "2016-03-14T18:49:17Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1Mjg4MDQyNzU2MDkzODg1NzY=",
        name: "template-3",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528804275609388576/original.png?1457981371",
        fileSize: "76452",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528804275609388576/small.png?1457981371",
        createdAt: "2016-03-14T18:49:32Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1Mjg4MDQyOTE4MDQ2MDgxMjA=",
        name: "template-4",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528804291804608120/original.png?1457981386",
        fileSize: "75520",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528804291804608120/small.png?1457981386",
        createdAt: "2016-03-14T18:49:47Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1Mjg4MDQzMDkwMjY0MjAyMDg=",
        name: "template-5",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528804309026420208/original.png?1457981403",
        fileSize: "47542",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528804309026420208/small.png?1457981403",
        createdAt: "2016-03-14T18:50:04Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1Mjg4MDQzMjUzNDQyMjI3MDE=",
        name: "template-6",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528804325344222701/original.png?1457981419",
        fileSize: "198270",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528804325344222701/small.png?1457981419",
        createdAt: "2016-03-14T18:50:19Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1Mjg4MDQzODIzNDE5MjQxMTU=",
        name: "template-2",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528804382341924115/original.png?1457981473",
        fileSize: "265063",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528804382341924115/small.png?1457981473",
        createdAt: "2016-03-14T18:51:14Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1Mjg4MDQzOTk0ODc3MDc2MjE=",
        name: "template-3",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528804399487707621/original.png?1457981489",
        fileSize: "76452",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528804399487707621/small.png?1457981489",
        createdAt: "2016-03-14T18:51:30Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1Mjg4MDQ0MTMwOTk1Mjg0MTA=",
        name: "template-4",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528804413099528410/original.png?1457981502",
        fileSize: "75520",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528804413099528410/small.png?1457981502",
        createdAt: "2016-03-14T18:51:43Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1Mjg4MDQ0NTYwMjI0NjMwNjA=",
        name: "template-5",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528804456022463060/original.png?1457981543",
        fileSize: "47542",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528804456022463060/small.png?1457981543",
        createdAt: "2016-03-14T18:52:24Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1Mjg4MDQ0NzQyNjM1ODM4NTc=",
        name: "template-6",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528804474263583857/original.png?1457981560",
        fileSize: "198270",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528804474263583857/small.png?1457981560",
        createdAt: "2016-03-14T18:52:41Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1Mjg4MDQ2Mjg5NDAzMjM1ODY=",
        name: "general_announcement",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528804628940323586/original.png?1457981708",
        fileSize: "276154",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528804628940323586/small.png?1457981708",
        createdAt: "2016-03-14T18:55:09Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1Mjg4MDU0NjU1Mzk5MDE0MTc=",
        name: "referral_hero",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528805465539901417/original.png?1457982506",
        fileSize: "348099",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528805465539901417/small.png?1457982506",
        createdAt: "2016-03-14T19:08:27Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1Mjg4MDU1MDk3NTY3OTI3ODI=",
        name: "referral_hero",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528805509756792782/original.png?1457982548",
        fileSize: "348099",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528805509756792782/small.png?1457982548",
        createdAt: "2016-03-14T19:09:09Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1Mjg4MDU1ODQzNzk4NjU5Mjk=",
        name: "event_invite_hero",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528805584379865929/original.png?1457982618",
        fileSize: "328072",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528805584379865929/small.png?1457982618",
        createdAt: "2016-03-14T19:10:20Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1Mjg4MDU2NzUzMDA2NjI0Njc=",
        name: "Schedule_a_Tour",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528805675300662467/original.png?1457982706",
        fileSize: "255660",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528805675300662467/small.png?1457982706",
        createdAt: "2016-03-14T19:11:47Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1Mjg4MDU3MTY2NzgxMjY3MDk=",
        name: "Schedule_a_Tour",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528805716678126709/original.png?1457982745",
        fileSize: "255660",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528805716678126709/small.png?1457982745",
        createdAt: "2016-03-14T19:12:26Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1Mjg4MTA1MzA1NTQzNzQ3ODg=",
        name: "shops",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528810530554374788/original.png?1457987336",
        fileSize: "249116",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528810530554374788/small.png?1457987336",
        createdAt: "2016-03-14T20:28:57Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1Mjg4MTEzODIwOTY4MzA3MDU=",
        name: "4thjuly",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528811382096830705/original.png?1457988148",
        fileSize: "349439",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528811382096830705/small.png?1457988148",
        createdAt: "2016-03-14T20:42:29Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1Mjg4MTM0NzQxODgwMDE2ODI=",
        name: "local-coffee",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528813474188001682/original.png?1457990144",
        fileSize: "302492",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528813474188001682/small.png?1457990144",
        createdAt: "2016-03-14T21:15:44Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1Mjg4MTM3MTY0OTg5MzI3ODY=",
        name: "Amenities",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528813716498932786/original.png?1457990375",
        fileSize: "184822",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528813716498932786/small.png?1457990375",
        createdAt: "2016-03-14T21:19:35Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1Mjg4MTUyODAyNzUwNjAwNjQ=",
        name: "Amenities_Copy",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528815280275060064/original.png?1457991866",
        fileSize: "374979",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528815280275060064/small.png?1457991866",
        createdAt: "2016-03-14T21:44:27Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1Mjg4MTcwMDU5MDEzNjIzNDA=",
        name: "refer_friend",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528817005901362340/original.png?1457993512",
        fileSize: "240138",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528817005901362340/small.png?1457993512",
        createdAt: "2016-03-14T22:11:53Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1Mjg4ODM0MjE0ODY0MDk0Njk=",
        name: "New_Years_Drop_Party",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528883421486409469/original.png?1458056851",
        fileSize: "322677",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528883421486409469/small.png?1458056851",
        createdAt: "2016-03-15T15:47:31Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1Mjg4ODUwMjQxNjg3MzY3ODc=",
        name: "chocolate",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528885024168736787/original.png?1458058379",
        fileSize: "95600",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528885024168736787/small.png?1458058379",
        createdAt: "2016-03-15T16:13:00Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1Mjg4ODUwNTExMzUxNzg4MTA=",
        name: "cups",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528885051135178810/original.png?1458058405",
        fileSize: "97564",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528885051135178810/small.png?1458058405",
        createdAt: "2016-03-15T16:13:26Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1Mjg4ODU2MzgwMDM2NjUxNTc=",
        name: "valentinesday_hero",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528885638003665157/original.png?1458058964",
        fileSize: "284681",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528885638003665157/small.png?1458058964",
        createdAt: "2016-03-15T16:22:45Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1Mjg4ODU3NzQ3OTczNjExNzc=",
        name: "chocolate",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528885774797361177/original.png?1458059095",
        fileSize: "95453",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528885774797361177/small.png?1458059095",
        createdAt: "2016-03-15T16:24:56Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1Mjg4ODU3OTMzODIzODQ1OTA=",
        name: "cups",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528885793382384590/original.png?1458059112",
        fileSize: "96607",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528885793382384590/small.png?1458059112",
        createdAt: "2016-03-15T16:25:13Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1Mjg4OTM2Njk0MDk3NjUzNTA=",
        name: "superbowlevent",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528893669409765350/original.png?1458066624",
        fileSize: "369577",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528893669409765350/small.png?1458066624",
        createdAt: "2016-03-15T18:30:25Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1Mjg4OTQ0MjA3MjE2NDY1ODg=",
        name: "cannedfood_drive",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528894420721646588/original.png?1458067340",
        fileSize: "318938",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528894420721646588/small.png?1458067340",
        createdAt: "2016-03-15T18:42:21Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1Mjg4OTU3OTMzMzU4MTE4ODk=",
        name: "easter_egg_drive",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528895793335811889/original.png?1458068650",
        fileSize: "316435",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528895793335811889/small.png?1458068650",
        createdAt: "2016-03-15T19:04:10Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1Mjg4OTY2ODM0NDc5MjE3NTA=",
        name: "halloween",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528896683447921750/original.png?1458069498",
        fileSize: "301906",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528896683447921750/small.png?1458069498",
        createdAt: "2016-03-15T19:18:19Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1Mjg5NzIxMzQyODg0NzYyNjA=",
        name: "team",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528972134288476260/original.png?1458141454",
        fileSize: "162452",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1528972134288476260/small.png?1458141454",
        createdAt: "2016-03-16T15:17:34Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1NTk1MTc5NDA5MDc3MjUyMjk=",
        name: "original",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1559517940907725229/original.png?1487272205",
        fileSize: "301021",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1559517940907725229/small.png?1487272205",
        createdAt: "2017-02-16T19:10:06Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1NjE4NzcwMTEzODg5Mjg5MTQ=",
        name: "ScheduleATour_(580x326)_v2",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1561877011388928914/original.png?1489521989",
        fileSize: "65104",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1561877011388928914/small.png?1489521989",
        createdAt: "2017-03-14T20:06:31Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1NjE4NzcyNTk4MzcyMTY5OTg=",
        name: "ScheduleATour_(580x326)_v2",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1561877259837216998/original.png?1489522226",
        fileSize: "311287",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1561877259837216998/small.png?1489522226",
        createdAt: "2017-03-14T20:10:28Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1NzEwODA4NTQ4NTQzMDM2OTY=",
        name: "transparent-test2",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1571080854854303696/original.png?1498299459",
        fileSize: "2847",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1571080854854303696/small.png?1498299459",
        createdAt: "2017-06-24T10:17:40Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1NzQ2MDE2MjIyMTI5ODc1NjE=",
        name: "fair_housing",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1574601622212987561/original.png?1501657123",
        fileSize: "1948",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1574601622212987561/small.png?1501657123",
        createdAt: "2017-08-02T06:58:45Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1NzQ2MDE3NTk4MzYzMzMyMzY=",
        name: "equal_housing",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1574601759836333236/original.png?1501657255",
        fileSize: "7546",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1574601759836333236/small.png?1501657255",
        createdAt: "2017-08-02T07:00:56Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1Nzk3MzAzOTQ5NDc3MzE1Mzg=",
        name: "fairfax_res_company_logo",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1579730394947731538/original.png?1506548303",
        fileSize: "2019",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1579730394947731538/small.png?1506548303",
        createdAt: "2017-09-27T21:38:24Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1Nzk3MzEwMDY0MTkzOTkwNjQ=",
        name: "fairfax_res_company_logo",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1579731006419399064/original.png?1506548886",
        fileSize: "2019",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1579731006419399064/small.png?1506548886",
        createdAt: "2017-09-27T21:48:07Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1ODA0OTIwNzc4MjIwNTM4NzQ=",
        name: "AdobeStock_168519172",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1580492077822053874/original.jpeg?1507274700",
        fileSize: "1382431",
        fileType: "JPEG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1580492077822053874/small.jpeg?1507274700",
        createdAt: "2017-10-06T07:25:01Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1ODA0OTIxNTI4MzE0NzA1MTc=",
        name: "AdobeStock_163278542",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1580492152831470517/original.jpeg?1507274771",
        fileSize: "1100552",
        fileType: "JPEG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1580492152831470517/small.jpeg?1507274771",
        createdAt: "2017-10-06T07:26:13Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1ODA0OTIxNTQ4MTMzNjI1MDM=",
        name: "AdobeStock_105416867",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1580492154813362503/original.jpeg?1507274772",
        fileSize: "724828",
        fileType: "JPEG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1580492154813362503/small.jpeg?1507274772",
        createdAt: "2017-10-06T07:26:15Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1ODA0OTIxNTYxNzkyMzQwMDc=",
        name: "AdobeStock_158326165",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1580492156179234007/original.jpeg?1507274773",
        fileSize: "1505953",
        fileType: "JPEG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1580492156179234007/small.jpeg?1507274773",
        createdAt: "2017-10-06T07:26:16Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1ODA0OTIxNTY3NTA2NTQwMzY=",
        name: "AdobeStock_116145068",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1580492156750654036/original.jpeg?1507274774",
        fileSize: "1811971",
        fileType: "JPEG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1580492156750654036/small.jpeg?1507274774",
        createdAt: "2017-10-06T07:26:17Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1ODA0OTIzNDk1MTU2MjQzNTU=",
        name: "AdobeStock_56366257",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1580492349515624355/original.jpeg?1507274959",
        fileSize: "1952682",
        fileType: "JPEG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1580492349515624355/small.jpeg?1507274959",
        createdAt: "2017-10-06T07:29:21Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1ODA1MzkwMjA4NjE1OTQzNDI=",
        name: "AdobeStock_105285716",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1580539020861594342/original.jpeg?1507319468",
        fileSize: "1014218",
        fileType: "JPEG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1580539020861594342/small.jpeg?1507319468",
        createdAt: "2017-10-06T19:51:10Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1ODA4NjM3NDQ3NzY1OTEyNDk=",
        name: "AdobeStock_133056052",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1580863744776591249/original.jpeg?1507629149",
        fileSize: "906788",
        fileType: "JPEG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1580863744776591249/small.jpeg?1507629149",
        createdAt: "2017-10-10T09:52:31Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1ODA4NjQ5OTEzNzI4NjM4MTM=",
        name: "AdobeStock_105416862",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1580864991372863813/original.jpeg?1507630338",
        fileSize: "1235109",
        fileType: "JPEG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1580864991372863813/small.jpeg?1507630338",
        createdAt: "2017-10-10T10:12:19Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1ODA4NjUyMTU3MzQ4NjEwMTM=",
        name: "AdobeStock_158326165",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1580865215734861013/original.jpeg?1507630550",
        fileSize: "1505953",
        fileType: "JPEG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1580865215734861013/small.jpeg?1507630550",
        createdAt: "2017-10-10T10:15:53Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1ODA4NjUyMTkzNDkxMDExMjI=",
        name: "AdobeStock_56366254",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1580865219349101122/original.jpeg?1507630553",
        fileSize: "1937782",
        fileType: "JPEG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1580865219349101122/small.jpeg?1507630553",
        createdAt: "2017-10-10T10:15:57Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1ODA4NjU4MzY2NzQ3OTExOTU=",
        name: "AdobeStock_95082119",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1580865836674791195/original.jpeg?1507631145",
        fileSize: "476317",
        fileType: "JPEG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1580865836674791195/small.jpeg?1507631145",
        createdAt: "2017-10-10T10:25:46Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1ODA4NjgzMDU5NTA5MDAzOTg=",
        name: "AdobeStock_133056041",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1580868305950900398/original.jpeg?1507633494",
        fileSize: "1175670",
        fileType: "JPEG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1580868305950900398/small.jpeg?1507633494",
        createdAt: "2017-10-10T11:05:01Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1ODA4NjgzMTQ2MDAyOTYxODE=",
        name: "AdobeStock_105416862_",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1580868314600296181/original.jpeg?1507633496",
        fileSize: "1235109",
        fileType: "JPEG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1580868314600296181/small.jpeg?1507633496",
        createdAt: "2017-10-10T11:05:09Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1ODA4NjgzMTQ3MjQxNTYzMDA=",
        name: "AdobeStock_105416913",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1580868314724156300/original.jpeg?1507633498",
        fileSize: "884287",
        fileType: "JPEG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1580868314724156300/small.jpeg?1507633498",
        createdAt: "2017-10-10T11:05:09Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1ODA4NjgzMTY1Nzk3ODA1NjI=",
        name: "AdobeStock_105416813",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1580868316579780562/original.jpeg?1507633501",
        fileSize: "861044",
        fileType: "JPEG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1580868316579780562/small.jpeg?1507633501",
        createdAt: "2017-10-10T11:05:11Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1ODA4Njk5NDgyMzk0NDE2ODk=",
        name: "AdobeStock_84251394",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1580869948239441689/original.jpeg?1507635063",
        fileSize: "1374746",
        fileType: "JPEG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1580869948239441689/small.jpeg?1507635063",
        createdAt: "2017-10-10T11:31:07Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1ODA4Njk5NDk5OTA0MTQ2MTM=",
        name: "AdobeStock_126791206",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1580869949990414613/original.jpeg?1507635065",
        fileSize: "1835700",
        fileType: "JPEG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1580869949990414613/small.jpeg?1507635065",
        createdAt: "2017-10-10T11:31:08Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1ODA4Njk5NTAxMzkzMjc4NTQ=",
        name: "AdobeStock_127880124",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1580869950139327854/original.jpeg?1507635065",
        fileSize: "2169733",
        fileType: "JPEG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1580869950139327854/small.jpeg?1507635065",
        createdAt: "2017-10-10T11:31:09Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1ODA4Njk5NTE2MDM3MDczNTQ=",
        name: "AdobeStock_56366254",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1580869951603707354/original.jpeg?1507635068",
        fileSize: "1937782",
        fileType: "JPEG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1580869951603707354/small.jpeg?1507635068",
        createdAt: "2017-10-10T11:31:10Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1ODA5NTI1MDUwMTY4NzkyMzA=",
        name: "AdobeStock_158325941",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1580952505016879230/original.jpeg?1507713797",
        fileSize: "1533460",
        fileType: "JPEG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1580952505016879230/small.jpeg?1507713797",
        createdAt: "2017-10-11T09:23:19Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1ODA5NTI1MTI2ODMxNzA1OTM=",
        name: "AdobeStock_73309923",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1580952512683170593/original.jpeg?1507713800",
        fileSize: "1212236",
        fileType: "JPEG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1580952512683170593/small.jpeg?1507713800",
        createdAt: "2017-10-11T09:23:26Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1ODA5NTI1MTU2MjMxOTM3NTg=",
        name: "AdobeStock_103702531",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1580952515623193758/original.jpeg?1507713801",
        fileSize: "1148882",
        fileType: "JPEG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1580952515623193758/small.jpeg?1507713801",
        createdAt: "2017-10-11T09:23:29Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1ODA5NTI1MTU3NDY4NjMzODA=",
        name: "AdobeStock_71091543",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1580952515746863380/original.jpeg?1507713802",
        fileSize: "1542648",
        fileType: "JPEG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1580952515746863380/small.jpeg?1507713802",
        createdAt: "2017-10-11T09:23:29Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1ODA5NTMzMzI4Nzk5OTUxMjU=",
        name: "AdobeStock_116145068",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1580953332879995125/original.jpeg?1507714585",
        fileSize: "1811971",
        fileType: "JPEG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1580953332879995125/small.jpeg?1507714585",
        createdAt: "2017-10-11T09:36:29Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1ODA5NTMzMzM0MjgzOTAwMTQ=",
        name: "AdobeStock_113970040",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1580953333428390014/original.jpeg?1507714586",
        fileSize: "1305213",
        fileType: "JPEG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1580953333428390014/small.jpeg?1507714586",
        createdAt: "2017-10-11T09:36:29Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1ODA5NTMzMzQ1NDIwMDAwODI=",
        name: "AdobeStock_77950418",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1580953334542000082/original.jpeg?1507714587",
        fileSize: "1786087",
        fileType: "JPEG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1580953334542000082/small.jpeg?1507714587",
        createdAt: "2017-10-11T09:36:30Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1ODA5NTUxMDUyOTAwODMzNjg=",
        name: "AdobeStock_95082119",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1580955105290083368/original.jpeg?1507716277",
        fileSize: "1707557",
        fileType: "JPEG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1580955105290083368/small.jpeg?1507716277",
        createdAt: "2017-10-11T10:04:39Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1ODI5NDYwMDUzOTU0MDYzMjY=",
        name: "AdobeStock_89659685",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1582946005395406326/original.jpeg?1509614947",
        fileSize: "1679881",
        fileType: "JPEG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1582946005395406326/small.jpeg?1509614947",
        createdAt: "2017-11-02T09:29:09Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1ODc0NzE4MDc3NjAzMjc5MDg=",
        name: "loading-gear",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1587471807760327908/original.gif?1513931089",
        fileSize: "8899",
        fileType: "GIF",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1587471807760327908/small.gif?1513931089",
        createdAt: "2017-12-22T08:24:51Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1OTMxNDA3MDU2NDI3MDg5MzQ=",
        name: "AdobeStock_63362818",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1593140705642708934/original.jpeg?1519337367",
        fileSize: "1185294",
        fileType: "JPEG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1593140705642708934/small.jpeg?1519337367",
        createdAt: "2018-02-22T22:09:33Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1OTMxNDA3MDYyOTUzOTI4NDg=",
        name: "AdobeStock_63363146",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1593140706295392848/original.jpeg?1519337367",
        fileSize: "781367",
        fileType: "JPEG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1593140706295392848/small.jpeg?1519337367",
        createdAt: "2018-02-22T22:09:34Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1OTMxNDA3MDg0NDIzNDU2MzE=",
        name: "AdobeStock_63362981",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1593140708442345631/original.jpeg?1519337369",
        fileSize: "989076",
        fileType: "JPEG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1593140708442345631/small.jpeg?1519337369",
        createdAt: "2018-02-22T22:09:36Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1OTMxNDA3MDkzNzE1Mzc4NTE=",
        name: "AdobeStock_115619849",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1593140709371537851/original.jpeg?1519337370",
        fileSize: "1661555",
        fileType: "JPEG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1593140709371537851/small.jpeg?1519337370",
        createdAt: "2018-02-22T22:09:36Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1OTMxNDA3MDk2MTU4MDc5OTg=",
        name: "AdobeStock_115619862",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1593140709615807998/original.jpeg?1519337371",
        fileSize: "2530561",
        fileType: "JPEG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1593140709615807998/small.jpeg?1519337371",
        createdAt: "2018-02-22T22:09:37Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1OTMxNDEzMDczNDk5MjY1Mjc=",
        name: "AdobeStock_158326165",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1593141307349926527/original.jpeg?1519337945",
        fileSize: "1506076",
        fileType: "JPEG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1593141307349926527/small.jpeg?1519337945",
        createdAt: "2018-02-22T22:19:07Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1OTMxNDE1MTMzMzE0NzUxNzk=",
        name: "AdobeStock_102940029",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1593141513331475179/original.jpeg?1519338140",
        fileSize: "2257054",
        fileType: "JPEG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1593141513331475179/small.jpeg?1519338140",
        createdAt: "2018-02-22T22:22:23Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1OTMxNDE1MTM4NDM3OTA3OTA=",
        name: "AdobeStock_78803300",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1593141513843790790/original.jpeg?1519338141",
        fileSize: "2092305",
        fileType: "JPEG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1593141513843790790/small.jpeg?1519338141",
        createdAt: "2018-02-22T22:22:24Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1OTMxNDE4NjI2NzAzNzc4NTY=",
        name: "AdobeStock_9961538",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1593141862670377856/original.jpeg?1519338474",
        fileSize: "1197080",
        fileType: "JPEG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1593141862670377856/small.jpeg?1519338474",
        createdAt: "2018-02-22T22:27:56Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE1OTU2MDY4MTczNjY1NDk1MDI=",
        name: "AdobeStock_113970040",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1595606817366549502/original.jpeg?1521689238",
        fileSize: "1302850",
        fileType: "JPEG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1595606817366549502/small.jpeg?1521689238",
        createdAt: "2018-03-22T03:27:20Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE2MjYwNzEyODEwMjg2NDQyMzU=",
        name: "2019-01-28_19-05-50",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1626071281028644235/original.png?1550742417",
        fileSize: "189191",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1626071281028644235/small.png?1550742417",
        createdAt: "2019-02-21T09:46:57Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE2MjYwNzE5MzgyODIxMjQ4NDI=",
        name: "2019-02-21_11-15-52",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1626071938282124842/original.png?1550743044",
        fileSize: "25341",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1626071938282124842/small.png?1550743044",
        createdAt: "2019-02-21T09:57:24Z"
      },
      {
        id: "TWt0Zzo6TGlicmFyeUFzc2V0LTE2MjYwOTEwOTEyNzEyNjA0NzE=",
        name: "ALM_Preface",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1626091091271260471/original.png?1550761309",
        fileSize: "25564",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1510679501769740702/library/1626091091271260471/small.png?1550761309",
        createdAt: "2019-02-21T15:01:49Z"
      }
    ]
  },
  {
    id: "TWt0Zzo6U2VjdGlvbi0xNTI4MjUyMjUzNTg1NTgxMjQwX19fdW5jbGFzc2lmaWVk",
    name: "Unclassified",
    type: "Sub-org",
    createdAt: "2016-03-08T16:35:23Z",
    hasMore: false,
    assets: [
      {
        id: "UHJvcDo6R2FsbGVyeUFzc2V0LTE1OTE5NTU0MjgwNjMzMzg0NDA=",
        name: "data",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1591955428063338440/Abe_Residential/Avenue_At_York/raw/original.?1518206993",
        fileSize: "4972633",
        fileType: "JPEG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1591955428063338440/Abe_Residential/Avenue_At_York/raw/small.?1518206993",
        createdAt: "2018-02-09T20:10:04Z"
      },
      {
        id: "UHJvcDo6R2FsbGVyeUFzc2V0LTE1OTE5NTU1NzI1ODQ1NDY4MzU=",
        name: "data",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1591955572584546835/Abe_Residential/Avenue_At_York/raw/original.?1518207129",
        fileSize: "3302106",
        fileType: "JPEG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1591955572584546835/Abe_Residential/Avenue_At_York/raw/small.?1518207129",
        createdAt: "2018-02-09T20:12:22Z"
      },
      {
        id: "UHJvcDo6R2FsbGVyeUFzc2V0LTE1OTE5NTU2MjYzMzUzODExMjY=",
        name: "data",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1591955626335381126/Abe_Residential/Avenue_At_York/raw/original.?1518207182",
        fileSize: "4285200",
        fileType: "JPEG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1591955626335381126/Abe_Residential/Avenue_At_York/raw/small.?1518207182",
        createdAt: "2018-02-09T20:13:13Z"
      },
      {
        id: "UHJvcDo6R2FsbGVyeUFzc2V0LTE1OTE5NTU2NzA4MjU2Mjg4MTc=",
        name: "data",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1591955670825628817/Abe_Residential/Avenue_At_York/raw/original.?1518207225",
        fileSize: "3648039",
        fileType: "JPEG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1591955670825628817/Abe_Residential/Avenue_At_York/raw/small.?1518207225",
        createdAt: "2018-02-09T20:13:56Z"
      },
      {
        id: "UHJvcDo6R2FsbGVyeUFzc2V0LTE1OTE5NTU5MDI4OTA2MTE0MzA=",
        name: "data",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1591955902890611430/Abe_Residential/Avenue_At_York/raw/original.?1518207441",
        fileSize: "2143779",
        fileType: "JPEG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1591955902890611430/Abe_Residential/Avenue_At_York/raw/small.?1518207441",
        createdAt: "2018-02-09T20:17:37Z"
      },
      {
        id: "UHJvcDo6R2FsbGVyeUFzc2V0LTE1OTE5NTU5NjcwMTg4NzIwMjA=",
        name: "data",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1591955967018872020/Abe_Residential/Avenue_At_York/raw/original.?1518207502",
        fileSize: "5172869",
        fileType: "JPEG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1591955967018872020/Abe_Residential/Avenue_At_York/raw/small.?1518207502",
        createdAt: "2018-02-09T20:18:38Z"
      },
      {
        id: "UHJvcDo6R2FsbGVyeUFzc2V0LTE1OTk4MTIxMDQ1NzEwMjU5MDM=",
        name: "data",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1599812104571025903/Abe_Residential/AvenueatYork/raw/original.?1525699708",
        fileSize: "3101821",
        fileType: "JPEG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1599812104571025903/Abe_Residential/AvenueatYork/raw/small.?1525699708",
        createdAt: "2018-05-07T13:28:35Z"
      },
      {
        id: "UHJvcDo6R2FsbGVyeUFzc2V0LTE2MjY4ODQ4MDQ5OTczOTg5MTg=",
        name: "data",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1626884804997398918/Abe_Residential/Avenue_at_York/raw/original.?1551518253",
        fileSize: "22902",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1626884804997398918/Abe_Residential/Avenue_at_York/raw/small.?1551518253",
        createdAt: "2019-03-02T09:17:34Z"
      },
      {
        id: "UHJvcDo6R2FsbGVyeUFzc2V0LTE2MzQ4NzMxNjIyNzY2ODIwMzk=",
        name: "data",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1634873162276682039/Abe_Residential/Avenue_at_York/raw/original.?1559136545",
        fileSize: "14826",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1634873162276682039/Abe_Residential/Avenue_at_York/raw/small.?1559136545",
        createdAt: "2019-05-29T13:29:05Z"
      },
      {
        id: "UHJvcDo6R2FsbGVyeUFzc2V0LTE2MzQ4NzMxNzkzODQyMzIzNjY=",
        name: "data",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1634873179384232366/Abe_Residential/Avenue_at_York/raw/original.?1559136561",
        fileSize: "6308",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1634873179384232366/Abe_Residential/Avenue_at_York/raw/small.?1559136561",
        createdAt: "2019-05-29T13:29:21Z"
      },
      {
        id: "UHJvcDo6R2FsbGVyeUFzc2V0LTE2MzQ4NzY2NDA5OTk2ODcyMjY=",
        name: "data",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1634876640999687226/Abe_Residential/Avenue_at_York/raw/original.?1559139862",
        fileSize: "2019",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1634876640999687226/Abe_Residential/Avenue_at_York/raw/small.?1559139862",
        createdAt: "2019-05-29T14:24:23Z"
      },
      {
        id: "UHJvcDo6R2FsbGVyeUFzc2V0LTE2MzQ4NzY4MDkzMTA1NzU2ODU=",
        name: "data",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1634876809310575685/Abe_Residential/Avenue_at_York/raw/original.?1559140023",
        fileSize: "7669",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1634876809310575685/Abe_Residential/Avenue_at_York/raw/small.?1559140023",
        createdAt: "2019-05-29T14:27:03Z"
      },
      {
        id: "UHJvcDo6R2FsbGVyeUFzc2V0LTE2MzQ4NzY5MDQwMzkxNTIxMzM=",
        name: "data",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1634876904039152133/Abe_Residential/Avenue_at_York/raw/original.?1559140113",
        fileSize: "1444",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1634876904039152133/Abe_Residential/Avenue_at_York/raw/original.?1559140113",
        createdAt: "2019-05-29T14:28:33Z"
      },
      {
        id: "UHJvcDo6R2FsbGVyeUFzc2V0LTE2MzQ4NzcyMjIzOTk2MTY0NDY=",
        name: "data",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1634877222399616446/Abe_Residential/Avenue_at_York/raw/original.?1559140417",
        fileSize: "31023",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1634877222399616446/Abe_Residential/Avenue_at_York/raw/small.?1559140417",
        createdAt: "2019-05-29T14:33:37Z"
      },
      {
        id: "UHJvcDo6R2FsbGVyeUFzc2V0LTE2MzQ4ODA5NjE4MjMxMDAyOTU=",
        name: "data",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1634880961823100295/Abe_Residential/Avenue_at_York/raw/original.?1559143983",
        fileSize: "425",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1634880961823100295/Abe_Residential/Avenue_at_York/raw/original.?1559143983",
        createdAt: "2019-05-29T15:33:03Z"
      },
      {
        id: "UHJvcDo6R2FsbGVyeUFzc2V0LTE2MzQ4ODA5ODAzMTAzNjU3Nzk=",
        name: "data",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1634880980310365779/Abe_Residential/Avenue_at_York/raw/original.?1559144001",
        fileSize: "792",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1634880980310365779/Abe_Residential/Avenue_at_York/raw/original.?1559144001",
        createdAt: "2019-05-29T15:33:21Z"
      },
      {
        id: "UHJvcDo6R2FsbGVyeUFzc2V0LTE2MzQ4ODEwMTQzMzUxNzQ2OTg=",
        name: "data",
        fileUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1634881014335174698/Abe_Residential/Avenue_at_York/raw/original.?1559144033",
        fileSize: "792",
        fileType: "PNG",
        thumbnailUrl:
          "https://s3.amazonaws.com/img.myhyly.stg2/1634881014335174698/Abe_Residential/Avenue_at_York/raw/original.?1559144033",
        createdAt: "2019-05-29T15:33:53Z"
      }
    ]
  }
];
